import { Component, OnInit, OnDestroy } from '@angular/core';
import { IssuerAPIService } from '../services/issuer-api.service';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { debug } from 'util';
import { parse } from 'querystring';
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function formatBytes(bytes, decimals): any;
declare function IssuerEmailBody(Url): any;
declare function PDFWelcomeMessage(eventId): any;
declare function ModelPopupMessage(speakText): any;
declare function VoiceOnKeyPress(value, key, eventId): any;
declare function MagnifierEnableDisable(targetid): any;
declare function makeOpenInstructions(file): string;
declare function makeFileDescription(file): string;
declare function ValidateEmail(emailid): boolean;
declare var $: any;
declare function FontSizeSettings(): any;

@Component({
  selector: 'app-compliance-review',
  templateUrl: './compliance-review.component.html',
  styleUrls: ['./compliance-review.component.css']
})
export class ComplianceReviewComponent implements OnInit, OnDestroy {
  public tableId: string;
  public OverViewCurrentIssueRows = 0;
  public OverViewNoIssueRows = 0;
  public ActiveBondsComplianceOverviewArray: any = [];
  public InActiveBondsComplianceOverviewArray: any = [];
  public downloadStatus = "";
  GenericTabIndex: number;
  public activefilingRows = 0
  public inactivefilingRows = 0;
  GenericTabNextIndex: number;
  GenericTabNextIndexN1: number;
  IssuesNoLongerIndex: number;
  IssuesNoLongerIndexN1: number;
  GenericTabIndexN1: number;
  FiscalYearEnd: string;
  CountCUSIPs: string;
  IncurrenceDate: string;
  SendMaildocumentLink: string;
  IssuerDefaultEmailBody: string;
  TemplateFileDocumentLink: string;
  TabSectionsCount: string;
  TableCounttabOverview: string;
  tablefindingsCount: number;
  TableFilingCounttabOverview: string;
  TableFilingHistoryCounttabOverview: string;
  TableFindingsCounttabOverview: string;
  public ActiveFilingRequirementsArray: any = [];
  public InActiveFilingRequirementsArray: any = [];
  public ComplianceTemplatesArray: any = [];;
  public ComplianceFilingHistoryArray = [];
  public EventNoticesComplianceFilingHistoryArray = [];
  public ComplianceReviewFindingsArray = [];
  public EventNoticesComplianceReviewFindingsArray = [];
  public IssuerCTDocumentationArray: any = [];
  public IssuerCTPoliciesAndProceduresArray: any = [];

  public fillinghistorytable_A: number = 0;
  public headTabIndex = 159;
  public headNextTabIndex = 160;
  public fillingTabIndex = 162;
  public filingR = 0;
  public filingE = 0;
  public footertabIndex = 80;

  public FHI = 1;
  public FHI2 = 2;

  constructor(private router: Router, private issuerAPIService: IssuerAPIService) {
   // set tab index for findings table
    this.tablefindingsCount = 100;
  }
  onkeypress(event: any) {
    debugger;
    if (event.target.id == "txtEmailBody" || event.target.id == "txtEmailIds") {
      VoiceOnKeyPress(event.target.value, event.key, event.target.id);
    }
  }
  onSectionKeyUp(event: any) {
    debugger;
    if (event.target.id == "sendEmail" && event.keyCode == 9) {
      ModelPopupMessage("Send to email address. A default email introduction is provided. Use tab to read or edit the introduction or tab twice to enter the email addresses of the recipients.");
      document.getElementById("lblSendtoEmailAddress").focus();
      document.getElementById("lblSendtoEmailAddress").tabIndex = 301;
      return;
    }
  }

  ClsoeEmailPopup(event: any) {
    debugger
    var recipientAddresses = <HTMLTextAreaElement>document.getElementById("txtEmailIds");
    recipientAddresses.value = "";
    var tableId = $("#hdtblid").val();
    var Ids = '#' + tableId + ' tr:gt(0)';
    var rowindex = $("#hdRowsIndex").val();
    $("#sendEmail").modal('hide');
    $(Ids).eq(rowindex).find('td').eq(5).focus();
    responsiveVoiceSpeak("", "Column Send Email. Press enter to send email. This is the last column. Use side arrow key to go to the next row.");
    return;
  }

  GetRowsMessage(rows: number): string {
    return rows.toString() + " records found."
  }
  countDynmaicTableRows(tableid) {
        debugger
        var rows = $("#" + tableid).find("tbody").find("tr:not('[class*=nodata]')").length;
        if (rows == 0) {
            return "0 record found.";
        }
        else {
            return rows + " records found."
        }

    }
  CounTableRows(tempStlen: any): string {
        if (tempStlen.length == 0) {
            return "0 record found.";
        }
        else {
            return tempStlen.length.toString() + " records found."
        }

    }

  onKeyUp(event: any) {
    debugger;
    // call voice on document popup
    if (event.target.id == "divwebcastVideo" && event.keyCode == 9) {
      document.getElementById("divwebcastVideo").focus();
      responsiveVoiceSpeak("", "Disclaimer. Use tab to read the disclaimer.");
      return;

    }

    if (event.target.id == "divwebcastVideo" && event.keyCode == 16) {
      document.getElementById("divwebcastVideo").focus();
      responsiveVoiceSpeak("", "Disclaimer. Use tab to read the disclaimer.");
      return;

    }

    // close email popup
    if (event.target.id == "CancelEmailDoc" && event.keyCode == 13) {
      this.ClsoeEmailPopup(event);
      return;
    }
    // dont accept or close disclaimer popup click
    if (event.target.id == "btndontccept" && event.keyCode == 13) {
      this.ClsoeTemplatePopup(event);
      return;
    }

    //download excel or word document to click on accept button
    if (event.target.id == "btnAccept" && event.keyCode == 13) {
      this.DownloadTemplateFile(event);
      return;
    }
    //read Terms 1 on Disclaimer popup
    if (event.target.id == "pop1" && event.keyCode == 9) {
      responsiveVoiceSpeak("Terms 1 ", "This Operating Data Template was compiled from all bond issues listed as currently outstanding in your DAC Bond portfolio. If any of the above listed bond issues are no longer outstanding please contact your Client Service Manager to have the issue(s) inactivated and removed from your annual Operating Data Template. Also, notify your Client Service Manager if any bond issues are missing from this template and need to be included in the template.");
    }
     //read Terms 2 on Disclaimer popup
    if (event.target.id == "pop2" && event.keyCode == 9) {
      responsiveVoiceSpeak("Terms 2 ", "This Operating Data Template represents the annual financial information and operating data requirements as interpreted and compiled by DAC from the forms of Continuing Disclosure Agreements contained in the Official Statements for all bond issues contained in your portfolio(or from the Official Statement summary language where the full Continuing Disclosure Agreement was not included in the Official Statement as an exhibit or addenda and has not been provided separately to DAC).Please review this template with counsel for accuracy and completeness of the annual financial information and operating data requirements and notify DAC of any changes to be made to the Operating Data Template.");
    }

    // accept terms 
    if (event.target.id == "terms" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Accept understanding above to view template.");
    }

    // disclaimer poup up accept button tabing
    if (event.target.id == "btnAccept" && event.keyCode == 9) {
      responsiveVoiceSpeak("Accept button", "Click here to Accept button to download the file.");
    }
    // disclaimer poup up dont accept button tabing
    if (event.target.id == "btndontccept" && event.keyCode == 9) {
      responsiveVoiceSpeak("Don't accept button", "Click here to Dont accept button to Close the disclaimer popup.");
    }
    if (event.target.id == "lblOverviewIssuesNoLongerOutstanding" && event.keyCode == 16) {
      document.getElementById("lblOverViewCurrentIssues").focus();
      // count rows message in table 
      responsiveVoiceSpeak("", "Current Issues." + this.GetRowsMessage(this.OverViewCurrentIssueRows) + " There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use enter to go to the table.");
          return;
      }
    if (event.target.id == "lblIssuesNLOInactive" && event.keyCode == 16) {
      document.getElementById("lblFilingOverViewCurrentIssues").focus();
      // count rows message in table 
      responsiveVoiceSpeak("", "Current Issues. " + this.GetRowsMessage(this.activefilingRows) + " There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use enter to go to the table.");
          return;
      }
    if (event.target.id == "lblComplianceReview1" && event.keyCode == 9) {
          responsiveVoiceSpeak("", "Event Notices. Use tab to go to next field. ");
          return;
      }
    if (event.target.id == "lbleventFindings" && event.keyCode == 9) {
          responsiveVoiceSpeak("", "Event Notices. Use tab to go to next field. ");
          return;
      }
    if (event.target.id == "lblOverviewIssuesNoLongerOutstanding" && event.keyCode == 9) {
      if (this.InActiveBondsComplianceOverviewArray == undefined) {
        responsiveVoiceSpeak("", "Issues No Longer Outstanding. 0 record found. There are two columns in this table. Use enter key to go to table. Use escape key to go to the footer.");
      }
      else 
          if (this.InActiveBondsComplianceOverviewArray.length == 0) {
              responsiveVoiceSpeak("", "Issues No Longer Outstanding. 0 record found. There are two columns in this table. Use enter key to go to table. Use escape key to go to the footer.");

          } else {
            responsiveVoiceSpeak("", "Issues No Longer Outstanding. " + this.OverViewNoIssueRows.toString() + "records found. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use enter to go to the table.");
          }
          return;
      }
    if (event.target.id == "lblIssuesNLOInactive" && event.keyCode == 9) {
          if (this.InActiveFilingRequirementsArray == undefined) {
              responsiveVoiceSpeak("", " Issues No Longer Outstanding. 0 record found. There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
          }
          else {
            // count table rows message
            responsiveVoiceSpeak("", " Issues No Longer Outstanding. " + this.GetRowsMessage(this.inactivefilingRows) + " There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
          }
          return;
      }

    //  tab to top section
    if (event.target.id == "pid" && event.keyCode == 16) {
      document.getElementById("head_1").focus();
      //document.getElementById("PageDMCA").tabIndex = 82;
      //document.getElementById("AboutUsPageTab").tabIndex = 83;
      return;
    }
    // go to footer
    if (event.target.id == "pid" && event.keyCode == 9 && event.shiftkey) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }

    // tab to footer
    if (event.target.id == "pid" && event.keyCode == 9) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }

     // tab to footer
    if (event.target.id == "pidnew" && event.keyCode == 16) {
      document.getElementById("headE_1").focus();
      return;
    }

     // tab to footer
    if (event.target.id == "pidnew" && event.keyCode == 9) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //responsiveVoiceSpeak("", "Overview section. This section provides list of Active and Inactive bonds issues with Official Statement document for each bond associated with this Obligor. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "pid" && event.keyCode == 16) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //responsiveVoiceSpeak("", "Overview section. This section provides list of Active and Inactive bonds issues with Official Statement document for each bond associated with this Obligor. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "lblTableCounttabOverview" && event.keyCode == 16) {
      document.getElementById("tabOverview").focus();
      //responsiveVoiceSpeak("", "Overview section. This section provides list of Active and Inactive bonds issues with Official Statement document for each bond associated with this Obligor. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "lblFilingTableCounttabOverview" && event.keyCode == 16) {
      document.getElementById("tabFilingRequirements").focus();
      //responsiveVoiceSpeak("", "Filing requirements section. This section provides Issue description and CDA and Summary language related to the obligor. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "lblTemplatesTableCoulmnCount" && event.keyCode == 16) {
      document.getElementById("tabTemplates").focus();
      //responsiveVoiceSpeak("", "Overview section. This section provides list of Active and Inactive bonds issues with Official Statement document for each bond associated with this Obligor. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "txtEmailBody" && event.keyCode == 9) {
      if (event.target.value == "") {
        ModelPopupMessage("Email introduction. Please enter an email introduction. This is an optional field.Use tab to go to the next field.");
      }
      else {
        ModelPopupMessage(event.target.value);
      }
    }
    if (event.target.id == "txtEmailIds" && event.keyCode == 9) {
      if (event.target.value == "") {
        ModelPopupMessage("Email address. Please enter an email address or enter multiple email addresses seperated by commas. This is a mandatory field. Use tab to go to the next field.");
      }
      else {
        ModelPopupMessage(event.target.value);
      }
    }
    if (event.target.id == "Emailthisdocument" && event.keyCode == 9) {
      ModelPopupMessage("Submit button. Press enter to email the document or use tab to go to the close button.");
    }
    if (event.target.id == "CancelEmailDoc" && event.keyCode == 9) {
      ModelPopupMessage("Cancel button. Press enter to cancel this operation and return back to the table.");
    }
    if (event.target.id == "sendEmail" && event.keyCode == 9) {
      ModelPopupMessage("Send to email address. A default email introduction is provided. Use tab to read or edit the introduction or tab twice to enter the email addresses of the recipients.");
      document.getElementById("lblSendtoEmailAddress").focus();
      document.getElementById("lblSendtoEmailAddress").tabIndex = 301;
      return;
    }
    if (event.target.id == "lblSendtoEmailAddress" && event.keyCode == 9) {
      ModelPopupMessage("Send to email address. A default email introduction is provided. Use tab to read or edit the introduction or tab twice to enter the email addresses of the recipients.");
      document.getElementById("lblSendtoEmailAddress").focus();
      document.getElementById("lblSendtoEmailAddress").tabIndex = 301;
      return;
    }
    if (event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if (event.target.id == "lblComplianceReview" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Compliance toolkit. Heading 1. Here you can access multiple sections to access information associated with this obligor. There are " + this.TabSectionsCount + " sections available. Use tab to go to the first section.");
    }
    if (event.target.id == "tabOverview" && event.keyCode == 9) {
      document.getElementById("tabOverview").click();
      responsiveVoiceSpeak("", "Overview section. This section provides list of Active and Inactive bonds issues with Official Statement document for each bond associated with this Obligor. Use enter key to view the section or use tab to go to the next section.");
    }
    if (event.target.id == "tabFilingRequirements" && event.keyCode == 9) {
      document.getElementById("tabFilingRequirements").click();
      responsiveVoiceSpeak("", "Filing requirements section. This section provides Issue description and CDA and Summary language related to the obligor. Use enter key to view the section or use tab to go to the next section.");
    }
    if (event.target.id == "tabTemplates" && event.keyCode == 9) {
      document.getElementById("tabTemplates").click();
      responsiveVoiceSpeak("", "Templates section. This section provides information of Operating Data templates. Use enter key to view the section or use tab to go to the next section.");
    }
    if (event.target.id == "tabFilingHistory" && event.keyCode == 9) {
      document.getElementById("tabFilingHistory").click();
      responsiveVoiceSpeak("", "Filing History section. This section provides information of filings of every category and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
    }
    if (event.target.id == "tabFindings" && event.keyCode == 9) {
      document.getElementById("tabFindings").click();
      responsiveVoiceSpeak("", "Findings section. This section provides information of filings of every category with daya late and Findings information and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
    }
    if (event.target.id == "tabDocumentation" && event.keyCode == 9) {
      document.getElementById("tabDocumentation").click();
      responsiveVoiceSpeak("", "Documentation section. This section provides information of Issuer requested documents. Use enter key to view the section or use tab to go to the next section.");
    }
    if (event.target.id == "tabPoliciesAndProcedures" && event.keyCode == 9) {
      document.getElementById("tabPoliciesAndProcedures").click();
      responsiveVoiceSpeak("", "Policies and procedures section. This provides information of Policies and Procedure documents. Use enter key to view the section or use tab to go to the footer.");
    }
    if (event.target.id == "lblOverViewCurrentIssues" && event.keyCode == 9) {
      // count table rows message
      responsiveVoiceSpeak("", "Current Issues. " + this.GetRowsMessage(this.OverViewCurrentIssueRows) + " There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use enter to go to the table.");
    }
    var whennotavailable = "Not available";

    if (event.target.id == "lblFilingOverViewCurrentIssues" && event.keyCode == 13) {
      var tableid = $(event.target).parent().next().next().attr("id");
      var id = $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").find("p");
      $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").focus();
      //
      if (id.text() == "" || id.text() == undefined) {
        responsiveVoiceSpeak("", "Column Issue Description. " + whennotavailable + ". Use right arrow key to go to next column.");
      }
      else {
        responsiveVoiceSpeak("", "Column Issue Description. " + id.text() + ". Use right arrow key to go to next column.");
      }
      return;
    }

    if (event.target.id == "lblIssuesNLOInactive" && event.keyCode == 13) {
      debugger;
      var tableid = $(event.target).parent().next().next().attr("id");
      var tablelength = $("#" + tableid).find("tbody").find("tr").length;
      var id = $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").find("p");
      $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").focus();

      if (id.text() == "" || id.text() == undefined || id.text() == "No data available!") {
        //No Records found in table then voice and caption read No data available! 
        if (tablelength == 1) {
          //$("#" + tableid).find("tr:gt(0):first").find("td").focus();
          responsiveVoiceSpeak("", "No data available!. Use escape key to go to footer. ");
        }
        else {
          responsiveVoiceSpeak("", "Column Issue Description. " + whennotavailable + ". Use right arrow key to go to next column.");
        }
      }
      else {
        responsiveVoiceSpeak("", "Column Issue Description. " + id.text() + ". Use right arrow key to go to next column.");
      }
      return;
    }


    if (event.target.id == "lblOverViewCurrentIssues" && event.keyCode == 13) {

      var tableid = $(event.target).parent().next().next().attr("id");
      var id = $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").find("p");
      $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").focus();
      if (id.text() == "" || id.text() == undefined) {
        responsiveVoiceSpeak("", "Column Issue Description. " + whennotavailable + ". Use right arrow key to go to next column.");
      }
      else {
        responsiveVoiceSpeak("", "Column Issue Description. " + id.text() + ". Use right arrow key to go to next column.");
      }
      return;
    }

   
    if (event.target.id == "lblOverviewIssuesNoLongerOutstanding" && event.keyCode == 13) {
      debugger;
      var tableid = $(event.target).parent().next().next().attr("id");
      var id = $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").find("p");
      $("#" + tableid).find("tr:gt(0):first").find("td:eq(0)").focus();
      var tablelength = $("#" + tableid).find("tbody").find("tr").length;

      if (id.text() == "" || id.text() == undefined || id.text() == "No data available!") {
      //No Records found in table then voice and caption read No data available! 
        if (tablelength == 1) {
         
          responsiveVoiceSpeak("", "No data available!. Use escape key to go to footer. ");
        }
        else
          responsiveVoiceSpeak("", "Column Issue Description. " + whennotavailable + ". Use right arrow key to go to next column.");
      }
      else {
        responsiveVoiceSpeak("", "Column Issue Description. " + id.text() + ". Use right arrow key to go to next column.");
      }
      return;
    }

    if (event.target.id == "lblFilingOverViewCurrentIssues" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Current Issues.  " + this.GetRowsMessage(this.activefilingRows) + " There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
    }
    if (event.target.id == "FiscalYearEnd" && (event.keyCode == 9)) {
      if (this.FiscalYearEnd == "") {
        responsiveVoiceSpeak("", "Fiscal year end date not available. Use tab to go to the next field.");
      }
      else {
        responsiveVoiceSpeak("", "Fiscal year end date " + this.FiscalYearEnd + ". Use tab to go to the next field.");
      }
    }
    if (event.target.id == "Cusip" && (event.keyCode == 9)) {
      if (this.CountCUSIPs == "") {
        responsiveVoiceSpeak("", "No cusip available. Use tab to go to the next field.");
      }
      else {
        responsiveVoiceSpeak("", "CUSIP(s) Reviewed. " + this.CountCUSIPs + ". cusips available. Use tab to go to the next field.");
      }
    }
    if (event.target.id == "Cusip" && (event.keyCode == 13)) {
      document.getElementById("CusipReviewed").click();
    }
    if (event.target.id == "IncurrenceDate" && (event.keyCode == 9)) {
      if (this.IncurrenceDate == "") {
        responsiveVoiceSpeak("", "Incurrence date not available. Use tab to go to the next field");
      }
      else {
        responsiveVoiceSpeak("", "Incurrence date. " + this.IncurrenceDate + ". Use tab to go to the next field.");
      }
    }
    if (event.target.id == "FiveYearFiling" && (event.keyCode == 9)) {
      responsiveVoiceSpeak("", "Five-Year-Filing History");
    }

      if (event.target.title == "head" && event.keyCode == 9) {
          var innertext = document.getElementById(event.target.id).innerText;
          document.getElementById(event.target.id).focus();
          if ($(event.target).parent().parent().next().attr("id")) {
              var id = $(event.target).parent().parent().next().attr("id");
              responsiveVoiceSpeak("", innertext + ". " + this.countDynmaicTableRows(id) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          }
          else {
              responsiveVoiceSpeak("", innertext + ". There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          }

      }

    //No Records found in table then voice and caption read No data available! 
    if (event.target.title == "CTCDoc" && event.keyCode == 9) {
      debugger;
      var innertext = document.getElementById(event.target.id).innerText;
      document.getElementById(event.target.id).focus();
      responsiveVoiceSpeak("", innertext + ". Use escape key to exit the table and go to footer.");
    }

    if (event.target.title == "titleHeadEvent1" && event.keyCode == 13) {
      if ($(event.target).parent().parent().next().attr("id")) {
        var id = $(event.target).parent().parent().next().attr("id");
        $("#" + id).find("tr:gt(0):first").find("td:eq(0)").focus();

        var txt = $("#" + id).find("tr:gt(0):first").find("td:eq(0)").find("p").text();
        //No Records found in table then voice and caption read No data available! 
        if (txt == "No data available!") {
          //No Records found in table then voice and caption read No data available! 
          responsiveVoiceSpeak("", "No data available!. Use escape key to go to footer. ");
        }
        else {
          this.ColumnDescription(txt);
        }
        return;
      }
    }

      if (event.target.title == "titleHeadEvent" && event.keyCode == 9) {
          debugger
          var innertext = document.getElementById(event.target.id).innerText;
          document.getElementById(event.target.id).focus();
          if ($(event.target).parent().parent().next().attr("id")) {
              var id = $(event.target).parent().parent().next().attr("id");
              responsiveVoiceSpeak("", innertext + ". " + this.countDynmaicTableRows(id) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          }
          else {
              responsiveVoiceSpeak("", innertext + ". " + this.countDynmaicTableRows(event.target.id) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          }
          return;

      }

      if (event.target.title == "titleHeadEvent1" && event.keyCode == 9) {
          debugger
          var innertext = document.getElementById(event.target.id).innerText;
          document.getElementById(event.target.id).focus();
          if ($(event.target).parent().parent().next().attr("id")) {
              var id = $(event.target).parent().parent().next().attr("id");
              responsiveVoiceSpeak("", innertext + ". " + this.countDynmaicTableRows(id) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          }
          else {
              responsiveVoiceSpeak("", innertext + ". " + this.countDynmaicTableRows(event.target.id) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          }

          return;
      }

    if (event.target.title == "titleHeadEvent" && event.keyCode == 13) {
      var dataindex = document.getElementById(event.target.id).tabIndex;
      var id = $(event.target).parent().parent().next().attr("id");
      $("#" + id).find("tr:gt(0):first").find("td:eq(0)").focus();
      var txt = $("#" + id).find("tr:gt(0):first").find("td:eq(0)").find("p").text();
      //No Records found in table then voice and caption read No data available! 
      if (txt == "No data available!") {
        responsiveVoiceSpeak("", "No data available!. Use escape key to go to footer. ");
      }
      else {
        this.ColumnDescription(txt);
      }
      //this.ColumnDescription(txt);
      //responsiveVoiceSpeak("", "Column Document Description. " + txt);
      return;
    }

    if (event.target.title == "head" && event.keyCode == 13) {
      var dataindex = document.getElementById(event.target.id).tabIndex;
      var id = $(event.target).parent().parent().next().attr("id");
      $("#" + id).find("tr:gt(0):first").find("td:eq(0)").focus();
      var txt = $("#" + id).find("tr:gt(0):first").find("td:eq(0)").find("p").text();
      //No Records found in table then voice and caption read No data available! 
      if (txt == "No data available!") {
        responsiveVoiceSpeak("", "No data available!. Use escape key to go to footer. ");
      }
      else {
        this.ColumnDescription(txt);
      }
      // responsiveVoiceSpeak("", "Column Document Description. " + txt);
      return;
    }
    // add for shift + tab to go to tab section
    debugger;
    if (event.target.id == "lblFindingsTableCount" && event.keyCode == 9 && event.shiftKey) {
      //document.getElementById("tabFindings").click();
      document.getElementById("tabFindings").focus();
      //responsiveVoiceSpeak("", "Findings section. This section provides information of filings of every category with daya late and Findings information and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "lblFindingsTableCount" && event.keyCode == 16) {
     // document.getElementById("tabFindings").click();
      document.getElementById("tabFindings").focus();
     //responsiveVoiceSpeak("", "Findings section. This section provides information of filings of every category with daya late and Findings information and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "lblFilingHistoryTableCounttabOverview" && event.keyCode == 9 && event.shiftKey) {
     // document.getElementById("tabFilingHistory").click();
      document.getElementById("tabFilingHistory").focus();
      //responsiveVoiceSpeak("", "Filing History section. This section provides information of filings of every category and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
      return;
    }

    if (event.target.id == "lblFilingHistoryTableCounttabOverview" && event.keyCode == 16) {
     // document.getElementById("tabFilingHistory").click();
      document.getElementById("tabFilingHistory").focus();
     // responsiveVoiceSpeak("", "Filing History section. This section provides information of filings of every category and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
      return;
    }
       
    if (event.target.id == "lblFindingsTableCoulmnCount" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "There are eight columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use tab to go to the table.");
    }
  };

  // All Events for Tabbing on Tables.
  // Overview Table

  TabEngine_Analysis(event: any, mode: string) {
    // Overview tab Start
    if (event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if (mode == "OverView") {

      //CURRENT ISSUES
      if ((event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewDocumentLink") && event.keyCode == 16) {
        document.getElementById("lblOverViewCurrentIssues").focus();
        return;
      }

      //ISSUES NO LONGER OUTSTANDING
      if ((event.target.id == "tdOverviewIssueDescriptionN" || event.target.id == "tdOverviewDocumentLinkN") && event.keyCode == 16) {
        document.getElementById("lblOverviewIssuesNoLongerOutstanding").focus();
        return;
      }
    }

    if (mode == "FillingRequirements") {

      if ((event.target.id == "sendEMailN" || event.target.id == "tdDocumentLinkN" || event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdDueDateEntitiesN" || event.target.id == "tddocumentDescN" || event.target.id == "tdCommencementDateN") && event.keyCode == 16) {
        document.getElementById("lblFilingOverViewCurrentIssues").focus();
        responsiveVoiceSpeak("", "Current Issues. There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
        return;
      }


      if ((event.target.id == "sendEMail" || event.target.id == "tdDocumentLink" || event.target.id == "tdDocumentDescription" || event.target.id == "tdDueDateEntities" || event.target.id == "tddocumentDesc" || event.target.id == "tdCommencementDate") && event.keyCode == 16) {
        document.getElementById("lblIssuesNLOInactive").focus();
        responsiveVoiceSpeak("", " Issues No Longer Outstanding. There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
        return;
      }
    }


  }

  onKeyUpOverview(event: any, file: any) {

    let openInstructions = makeOpenInstructions(file);

    debugger;
    if (event.keyCode != 17) {

      this.TabEngine_Analysis(event, "OverView");

      if ((event.target.id == "tdDocumentLinkN" || event.target.id == "sendEMail") && event.keyCode == 9) {
        document.getElementById("lblIssuesNLOInactive").focus();
        responsiveVoiceSpeak("", "Issues No Longer Outstanding. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
      }

      if ((event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewDocumentLink") && event.keyCode == 9 && event.target.tabIndex != this.GenericTabIndex && event.target.tabIndex < this.IssuesNoLongerIndex) {
        document.getElementById("lblOverviewIssuesNoLongerOutstanding").focus();
        responsiveVoiceSpeak("", "Issues No Longer Outstanding. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
      }
      if (event.target.id == "tdOverviewDocumentLink" && event.keyCode == 9 && event.target.tabIndex == this.GenericTabIndex) {
        document.getElementById("lblOverviewIssuesNoLongerOutstanding").focus();
        responsiveVoiceSpeak("", "Issues No Longer Outstanding. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
      }
      if ((event.target.id == "tdOverviewIssueDescriptionN" || event.target.id == "tdOverviewDocumentLinkN" || event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewDocumentLink") && event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      }
      //if (event.target.id == "tdOverviewIssueDescription" && event.keyCode == 9) {
      //  responsiveVoiceSpeak("", "Column Issue Description. " + event.target.innerText);
      //}

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewIssueDescriptionN") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          if (innerText == "" || innerText == undefined) {
            innerText = "Not available";
          }
          responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column. ");
        }
        if (event.target.id == "tdOverviewDocumentLink" || event.target.id == "tdOverviewDocumentLinkN") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. Not available. This is the last column. Use side arrow key to go to the next row.");
          }
          else {
            responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
          }
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewIssueDescriptionN") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          if (innerText == "" || innerText == undefined) {
            innerText = "Not available";
          }
          responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column. ");

        }
        if (event.target.id == "tdOverviewDocumentLink" || event.target.id == "tdOverviewDocumentLinkN") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. " + openInstructions + " This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;
      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewIssueDescriptionN") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdOverviewDocumentLink" || target[0].id == "tdOverviewDocumentLinkN") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. " + openInstructions + " This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        if (event.target.id == "tdOverviewDocumentLink" || event.target.id == "tdOverviewDocumentLinkN") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdOverviewDocumentLink" || event.target.id == "tdOverviewDocumentLinkN") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              if (innerText == "" || innerText == undefined) {
                innerText = "Not available";
              }
              responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column. ");
            }
          }
        }
        return;
      }
      else if (event.keyCode == 37) {
        var inntertext = "Not available";
        if (event.target.id == "tdOverviewDocumentLink" || event.target.id == "tdOverviewDocumentLinkN") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdOverviewIssueDescription" || target[0].id == "tdOverviewIssueDescriptionN") {
            if (target[0].innerText == "" || target[0].innerText == undefined) {
              inntertext = "Not available";
            }
            responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column. ");
            // responsiveVoiceSpeak("", "Column Issue Description. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewIssueDescriptionN") {
          $(event.target).parent().prev().children("td").eq(1).focus();
          if (event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewIssueDescriptionN") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
              if (innerText == "") {
                responsiveVoiceSpeak("", "Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Borrowing Documents / Official Statement " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        return;
      }
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
    }
  }

  // Cloumns for finding the values as required in table 
  ColumnFindings(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Findings. " + innerText + ". Use right arrow key to go to next column.");
  }
  ColumnDaysLate(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Days Late. " + innerText + ". Use right arrow key to go to next column.");
  }
  ColumnDueDate(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Due Date. " + innerText + ". Use right arrow key to go to next column.");
  }
  ColumnDescription(innerText: string, colname = "Column Issue Description. ") {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", colname + innerText + ". Use right arrow key to go to next column.");
  }
  ColumnDocDate(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Doc Date. " + innerText + ". Use right arrow key to go to next column.");
  }
  ColumnFilingInterval(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Filing Interval. " + innerText + ". Use right arrow key to go to next column.");

  }
  ColumnDisclosureType(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Disclosure Type. " + innerText + ". Use right arrow key to go to next column.");

  }
  ColumnDacDocument(file: any, openInstructions: string) {
    var innerText = "";
    var filestr = file.documentLink;
    if (filestr == "" || filestr == undefined) {
      innerText = "Not available";
      responsiveVoiceSpeak("", "Column DAC Document. " + innerText + ". Use right arrow key to go to next column.");
    }
    else {
      responsiveVoiceSpeak("", "Column DAC Document. " + openInstructions + " Use right arrow key to go to next column.");
    }
  }
  ColumnFilingCertificates(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Filing Certificates. " + innerText + ". Please contact your Client Service manager to obtain the document. Use right arrow key to go to next column.");
  }
  ColumnFilingDate(innerText: string) {
    if (innerText == "" || innerText == undefined) {
      innerText = "Not available";
    }
    responsiveVoiceSpeak("", "Column Filing Date. " + innerText + ". Use right arrow key to go to next column.");
  }
  // Filing Requirements Table
  onKeyUpFilingRequirements(event: any, file: any) {
    let openInstructions = makeOpenInstructions(file);
    debugger;
    if (event.keyCode != 17) {
      this.TabEngine_Analysis(event, "FillingRequirements");
      //&& event.target.tabIndex != this.GenericTabIndex && event.target.tabIndex < this.IssuesNoLongerIndex
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
      if ((event.target.id == "tddocumentDescN" || event.target.id == "sendEMailN" || event.target.id == "tdDocumentLinkN" || event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdCommencementDateN" || event.target.id == "tdDueDateEntitiesN") && event.keyCode == 9 && event.target.tabIndex != this.GenericTabIndex && event.target.tabIndex < this.IssuesNoLongerIndexN1) {
        document.getElementById("lblIssuesNLOInactive").focus();
        responsiveVoiceSpeak("", " Issues No Longer Outstanding. There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use enter to go to the table.");
        return;
      }
      if ((event.target.id == "sendEMail" || event.target.id == "tdDocumentLinkN" || event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdCommencementDateN" || event.target.id == "tdDueDateEntitiesN") && event.keyCode == 9) {
        document.getElementById("lblIssuesNLOInactive").focus();
        responsiveVoiceSpeak("", " Issues No Longer Outstanding. There are six columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use enter to go to the table.");
        return;

      }
      //if ((event.target.id == "tdOverviewIssueDescription" || event.target.id == "tdOverviewDocumentLink") && event.keyCode == 9 && event.target.tabIndex != this.GenericTabIndex && event.target.tabIndex < this.IssuesNoLongerIndex) {
      //  document.getElementById("lblOverviewIssuesNoLongerOutstanding").focus();
      //  responsiveVoiceSpeak("", "Issues No Longer Outstanding. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
      //}
      if ((event.target.id == "tddocumentDescN" || event.target.id == "tddocumentDesc") && event.keyCode == 9) {

        responsiveVoiceSpeak("", "Column Issue Description. " + event.target.innerText);
      }
      //Open send email popup for send email the document.
      if ((event.target.id == "sendEMailN" || event.target.id == "sendEMail") && event.keyCode == 13) {
        ModelPopupMessage("Send to email address. A default email introduction is provided. Use tab to read or edit the introduction or tab twice to enter the email addresses of the recipients.");
        $("#sendEmail").modal('show');
        document.getElementById("lblSendtoEmailAddress").focus();
        document.getElementById("lblSendtoEmailAddress").tabIndex = 301;

        $("#hdtblid").val($(event.target).parents("table").attr("id"));
        $("#hdRowsIndex").val($(event.target).parents("tr").index());
        return;
      }
      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDescN" || event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          if (innerText == "" || innerText == undefined) {
            innerText == "Not available";
            responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column.");

          }

        }
        if (event.target.id == "tdCommencementDateN" || event.target.id == "tdCommencementDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Commencement Date. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Commencement Date. " + innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDueDateEntitiesN" || event.target.id == "tdDueDateEntities") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Due Dates/Entities. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Due Dates/Entities. " + innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdDocumentDescription") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Document Description. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Document Description. " + innerText + " " + openInstructions + " Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDocumentLinkN" || event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Docs. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Docs. " + openInstructions + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "sendEMailN" || event.target.id == "sendEMail") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Send Email. Not available. This is the last column. Use side arrow key to go to the next row.");
          }
          else {
            responsiveVoiceSpeak("", "Column Send Email. Press enter to send email. This is the last column. Use side arrow key to go to the next row.");
          }
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDescN" || event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          if (innerText == "" || innerText == undefined) {
            innerText == "Not available";
          }
          responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column.");

        }
        if (event.target.id == "tdCommencementDateN" || event.target.id == "tdCommencementDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Commencement Date. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Commencement Date. " + innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDueDateEntitiesN" || event.target.id == "tdDueDateEntities") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Due Dates/Entities. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Due Dates/Entities. " + innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdDocumentDescription") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Document Description. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Document Description. " + innerText + " " + openInstructions + " Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDocumentLink" || event.target.id == "tdDocumentLinkN") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Docs. Not available. Use right arrow key to go to next column.");
          }
          else {
            responsiveVoiceSpeak("", "Column Docs. " + openInstructions + " Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "sendEMailN" || event.target.id == "sendEMail") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Send Email. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Send Email. Press enter to send email. This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Send Email. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Send Email. Press enter to send email. This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;
      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tddocumentDescN" || event.target.id == "tddocumentDesc") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdCommencementDateN" || target[0].id == "tdCommencementDate") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Commencement Date. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Commencement Date. " + target[0].innerText + ". Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdCommencementDateN" || event.target.id == "tdCommencementDate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDueDateEntitiesN" || target[0].id == "tdDueDateEntities") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Due Dates/Entities. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Due Dates/Entities. " + target[0].innerText + ". Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdDueDateEntitiesN" || event.target.id == "tdDueDateEntities") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentDescriptionN" || target[0].id == "tdDocumentDescription") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Document Description. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText + " " + openInstructions + " Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdDocumentDescription") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLinkN" || target[0].id == "tdDocumentLink") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Docs. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Docs. " + openInstructions + " Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdDocumentLinkN" || event.target.id == "tdDocumentLink") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "sendEMailN" || target[0].id == "sendEMail") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Send Email. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Send Email. Press enter to send email. This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Send Email. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Send Email. Press enter to send email. This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        if (event.target.id == "sendEMailN" || event.target.id == "sendEMail") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "sendEMailN" || event.target.id == "sendEMail") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              if (innerText == "" || innerText == undefined) {
                innerText = "Not available";
              }
              responsiveVoiceSpeak("", "Column Issue Description. " + innerText + ". Use right arrow key to go to next column.");
            }
          }
        }
      }
      else if (event.keyCode == 37) {
        if (event.target.id == "tdDocumentLinkN" || event.target.id == "tdDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentDescriptionN" || target[0].id == "tdDocumentDescription") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Document Description. Not available" + ". Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText + ". Use right arrow key to go to next column.");
            }

          }
        }
        if (event.target.id == "tdDocumentDescriptionN" || event.target.id == "tdDocumentDescription") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDueDateEntitiesN" || target[0].id == "tdDueDateEntities") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Due Dates/Entities. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Due Dates/Entities. " + target[0].innerText + ". Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdDueDateEntitiesN" || event.target.id == "tdDueDateEntities") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdCommencementDateN" || target[0].id == "tdCommencementDate") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Commencement Date. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Commencement Date. " + target[0].innerText + ". Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdCommencementDateN" || event.target.id == "tdCommencementDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDescN" || target[0].id == "tddocumentDesc") {
            responsiveVoiceSpeak("", "Column Issue Description. " + target[0].innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "sendEMailN" || event.target.id == "sendEMail") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLinkN" || target[0].id == "tdDocumentLink") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Docs. Not available. Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Docs. " + openInstructions + " Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tddocumentDescN" || event.target.id == "tddocumentDesc") {
          $(event.target).parent().prev().children("td").eq(5).focus();
          if (event.target.id == "tddocumentDescN" || event.target.id == "tddocumentDesc") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
              responsiveVoiceSpeak("", "Column Send Email. This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
      }

    }
  }
  // to check table data in template table 
  GetTemplate_AvailableMessage(): boolean {
    var Istrue = false;
    var tablelength = $("#tblTemplateArray").find("tbody").find("tr").length;
    var id = $("#tblTemplateArray").find("tr:gt(0):first").find("td:eq(0)").find("p");
    if (id.text() == "No data available!") {
      if (tablelength == 1) {
        Istrue = true;
        responsiveVoiceSpeak("", "No data available!. Use escape key to go to footer. ");
      }

    }

    return Istrue;
  }
  // Templates Table
  onKeyUpTemplates(event: any, file: any) {
    let openInstructions = makeOpenInstructions(file);
    debugger;
    if (event.keyCode != 17) {

      if (event.target.id == "tdDocumentLink" && event.keyCode == 9) {
        document.getElementById("divwebcastVideo").focus();
        responsiveVoiceSpeak("", "Disclaimer. Use tab to read the disclaimer.");
        return;
      }

      if (event.target.id == "tdDocumentLink" && event.keyCode == 13) {
        this.showTemplateModal(file, event);
        return;
      }
      // add more column to use shift + tab
      if ((event.target.id == "tdDocumentLink" || event.target.id == "tdDisclosureType" || event.target.id == "tdFilingInterval" || event.target.id == "tdDocDate" || event.target.id == "tddocumentDesc" || event.target.id == "tdDocumentLink1" || event.target.id == "tdDisclosureType1" || event.target.id == "tdFilingInterval1" || event.target.id == "tdDocDate1" || event.target.id == "tddocumentDesc1") && event.keyCode == 16) {
        document.getElementById("tabTemplates").focus();
        // responsiveVoiceSpeak("", "Templates section. This section provides information of Operating Data templates. Use enter key to view the section or use tab to go to the next section.");
        return;
      }
      if (event.target.id == "tddocumentDesc1" && event.keyCode == 9 && !event.shiftKey) {
        debugger;

        if (this.GetTemplate_AvailableMessage()) {

        }
        else {
          this.ColumnDescription(event.target.innerText);
        }
        //responsiveVoiceSpeak("", "Column Document Description	. " + event.target.innerText);
      }
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDesc1") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          this.ColumnDescription(innerText);
        }
        if (event.target.id == "tdDocDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDocDate(innerText);
        }
        if (event.target.id == "tdFilingInterval") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          this.ColumnFilingInterval(innerText);
        }
        if (event.target.id == "tdDisclosureType") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          this.ColumnDisclosureType(innerText);
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
          responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDesc1") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          this.ColumnDescription(innerText);
        }
        if (event.target.id == "tdDocDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDocDate(innerText);
        }
        if (event.target.id == "tdFilingInterval") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          this.ColumnFilingInterval(innerText);
        }
        if (event.target.id == "tdDisclosureType") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          this.ColumnDisclosureType(innerText);
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Document. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Document. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;
      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tddocumentDesc1") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocDate") {
            this.ColumnDocDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Doc Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDocDate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingInterval") {
            this.ColumnFilingInterval(target[0].innerText)
            //responsiveVoiceSpeak("", "Column Filing Interval. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFilingInterval") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDisclosureType") {
            this.ColumnDisclosureType(target[0].innerText);
            // responsiveVoiceSpeak("", "Column Disclosure Type. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDisclosureType") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLink") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Document. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Document. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        if (event.target.id == "tdDocumentLink") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdDocumentLink") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              this.ColumnDescription(innerText);
              //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
            }
          }
        }
      }
      else if (event.keyCode == 37) {
        if (event.target.id == "tdDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDisclosureType") {
            this.ColumnDisclosureType(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Disclosure Type. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDisclosureType") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingInterval") {
            this.ColumnFilingInterval(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Interval. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFilingInterval") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDocDate") {
            this.ColumnDocDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Doc Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDocDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDesc1") {
            this.ColumnDescription(target[0].innerText);
            // responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText);
          }
        }
        if (event.target.id == "tddocumentDesc1") {
          $(event.target).parent().prev().children("td").eq(4).focus();
          if (event.target.id == "tddocumentDesc1") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
              responsiveVoiceSpeak("", "Column Document. This is the last column. " + openInstructions + " Use side arrow key to go to the next row.");
            }
          }
        }
      }
    }
  }
  // Filing History Table
  onKeyUpFilingHistory(event: any, file: any) {
    debugger;
    let openInstructions = "Press enter to open the document."//makeOpenInstructions(file);
    var tablecount = this.TableFilingHistoryCounttabOverview;
    if (event.keyCode != 17) {
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
      if ((event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates" || event.target.id == "tddocumentDescFillingH") && event.keyCode == 16) {
        $("#" + this.tableId).focus();
        //$(event.target).parents("table").prev().find("[id*=head]").focus();
        return;

      }

      if ((event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates" || event.target.id == "tddocumentDescFillingH") && event.keyCode == 9) {
        if ($(event.target).parents("table").next().find("[id*=head]").length > 0) {
          $(event.target).parents("table").next().find("[id*=head]").focus();
          var innertext = $(event.target).parents("table").next().find("[id*=head]").text();
          responsiveVoiceSpeak("", innertext + ". There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");
          return;
        }
        else if ($(event.target).parents("table").next().find("[id*=lblComplianceReview1]").length > 0) {
          $(event.target).parents("table").next().find("[id*=lblComplianceReview1]").focus();

        }


        else {
          if (event.target.id == "tdFilingDate" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(3).focus();
          }
          if (event.target.id == "tdDACDocument" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(0).focus();
          }

          if (event.target.id == "tdFilingDueDate" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(2).focus();
          }

          if (event.target.id == "tdFilingCertificates" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(1).focus();
          }


        }
        return;
      }

      if ((event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates") && event.keyCode == 9 && event.target.tabIndex == this.fillingTabIndex) {
        if ($(event.target).parents("table")[0].id != undefined) {
          var tableno = $(event.target).parents("table")[0].id;
          tableno = parseInt(tableno) + 1;
          if (tableno <= this.fillinghistorytable_A) {
            document.getElementById(tableno).focus();
            //responsiveVoiceSpeak("", "Issues No Longer Outstanding. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
            return;
          }
        }

      }

      if (event.target.id == "tddocumentDesc" && event.keyCode == 9) {
        responsiveVoiceSpeak("", "Column Document Description. " + event.target.innerText);
      }

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDescFillingH") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          this.ColumnDescription(innerText);
        }
        if (event.target.id == "tdDACDocument") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDacDocument(file, openInstructions);
        }
        if (event.target.id == "tdFilingCertificates") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          this.ColumnFilingCertificates(innerText);
        }
        if (event.target.id == "tdFilingDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          this.ColumnFilingDate(innerText);
          //responsiveVoiceSpeak("", "Column Filing Date. " + innerText);
        }
        if (event.target.id == "tdFilingDueDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Filing Due Date. Not available.");
          }
          else {
            responsiveVoiceSpeak("", "Column Filing Due Date. " + innerText + "This is the last column. Use side arrow key to go to the next row.");
          }
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDescFillingH") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          this.ColumnDescription(innerText);
          //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
        }
        if (event.target.id == "tdDACDocument") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDacDocument(file, openInstructions);
        }
        if (event.target.id == "tdFilingCertificates") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          this.ColumnFilingCertificates(innerText);
          //responsiveVoiceSpeak("", "Column Filing Certificates. " + innerText + " Please contact your Client Service manager to obtain the document.");
        }
        if (event.target.id == "tdFilingDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          this.ColumnFilingDate(innerText);
          //responsiveVoiceSpeak("", "Column Filing Date. " + innerText);
        }
        if (event.target.id == "tdFilingDueDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Filing Due Date. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Filing Due Date. " + innerText + ". This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Filing Due Date. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Filing Due Date. " + innerText + ". This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;

      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tddocumentDescFillingH") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDACDocument") {
            this.ColumnDacDocument(file, openInstructions);
            //responsiveVoiceSpeak("", "Column DAC Document. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDACDocument") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingCertificates") {
            this.ColumnFilingCertificates(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Certificates. " + target[0].innerText + " Please contact your Client Service manager to obtain the document.");
          }
        }
        if (event.target.id == "tdFilingCertificates") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingDate") {
            this.ColumnFilingDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFilingDate") {
          var target = $(event.target).next();
          $(event.target).next().trigger('focus');
          if (target[0].id == "tdFilingDueDate") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Filing Due Date. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Filing Due Date. " + target[0].innerText + ". This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Filing Due Date. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Filing Due Date. " + target[0].innerText + ". This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }

          return;
        }
        if (event.target.id == "tdFilingDate") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdFilingDate") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              this.ColumnDescription(innerText);
              //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
            }
          }
        }
        if (event.target.id == "tdFilingDueDate") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdFilingDueDate") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              this.ColumnDescription(innerText);
              //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
            }
          }
        }
      }
      else if (event.keyCode == 37) {
        if (event.target.id == "tdFilingDueDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingDate") {
            this.ColumnFilingDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFilingDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingCertificates") {
            this.ColumnFilingCertificates(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Certificates. " + target[0].innerText + " Please contact your Client Service manager to obtain the document.");
          }
        }
        if (event.target.id == "tdFilingCertificates") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDACDocument") {
            this.ColumnDacDocument(file, openInstructions);
          }
        }
        if (event.target.id == "tdDACDocument") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDescFillingH") {
            this.ColumnDescription(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText);
          }
        }
        if (event.target.id == "tddocumentDescFillingH") {
          $(event.target).parent().prev().children("td").eq(4).focus();
          if (event.target.id == "tddocumentDescFillingH") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
              if (innerText == "") {
                responsiveVoiceSpeak("", "Column Filing Due Date. Not available.");
              }
              else {
                responsiveVoiceSpeak("", "Column Filing Due Date. " + innerText + "This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
      }
    }
  }

  // find table and  set table id to go focus
  onfindings(event: any) {
    this.tableId = $(event.target).parents("table").prev().find("[id*=head]").attr("id");
    return;
  }
  // set table id on foucs to go focus
  onkeyFindingFoucus(event: any, file: any) {
    debugger;
    this.tableId = $(event.target).parents("table").prev().find("[id*=head]").attr("id");

    return;
  }

  // Findings Table
  onKeyUpFindings(event: any, file: any) {
    debugger;
    let openInstructions = "Press enter to open the document."
    if (event.keyCode != 17) {
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }

      // set foucs on table 
      if ((event.target.id == "td" || event.target.id == "tdDocumentLink" || event.target.id == "tdDaysLate" || event.target.id == "tdComments" || event.target.id == "tdFindings" || event.target.id == "tdDueDate" || event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates" || event.target.id == "tddocumentDescFillingH") && event.keyCode == 16) {
        $("#" + this.tableId).focus();
        return;

      }

      //if ((event.target.id == "tdDueDate" || event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates" || event.target.id == "tddocumentDescFillingH") && event.keyCode == 16) {
      //  $(event.target).parents("table").prev().find("[id*=head]").focus();
      //  return;

      //}
      if ((event.target.id == "tdDueDate" || event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates" || event.target.id == "tddocumentDescFillingH") && event.keyCode == 9) {
        if ($(event.target).parents("table").next().find("[id*=head]").length > 0) {
          $(event.target).parents("table").next().find("[id*=head]").focus();
          var innertext = $(event.target).parents("table").next().find("[id*=head]").text();
          responsiveVoiceSpeak("", innertext + ". There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use enter to go to the table.");

          return;
        }
        else {
          if (event.target.id == "tdFilingDate" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(3).focus();
          }
          if (event.target.id == "tdDACDocument" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(0).focus();
          }

          if (event.target.id == "tdFilingDueDate" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(2).focus();
          }

          if (event.target.id == "tdFilingCertificates" && event.keyCode == 9) {
            $(event.target).parent().children("td").eq(1).focus();
          }


        }
        return;
      }
      if ((event.target.id == "tdFilingDate" || event.target.id == "tdFilingDueDate" || event.target.id == "tdDACDocument" || event.target.id == "tdFilingCertificates") && event.keyCode == 9 && event.target.tabIndex == this.fillingTabIndex) {
        if ($(event.target).parents("table")[0].id != undefined) {
          var tableno = $(event.target).parents("table")[0].id;
          tableno = parseInt(tableno) + 1;
          if (tableno <= this.fillinghistorytable_A) {
            document.getElementById(tableno).focus();
            //responsiveVoiceSpeak("", "Issues No Longer Outstanding. There are two columns in this table. Use up-down and left-right arrow keys to navigate the table. While in the table, use tab to skip to the next table or use escape key to go to the footer. Use tab to go to the table.");
            return;
          }
        }

      }
      if (event.target.id == "tddocumentDesc" && event.keyCode == 9) {
        this.ColumnDescription(event.target.innerText, "Column Document Description. ");
        //responsiveVoiceSpeak("", "Column Document Description. " + event.target.innerText);
      }

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDescFillingH") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
          this.ColumnDescription(innerText);
        }
        if (event.target.id == "tdDueDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDueDate(innerText);
          //responsiveVoiceSpeak("", "Column Due Date. " + innerText);
        }
        if (event.target.id == "tdFindingsFilingDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          //responsiveVoiceSpeak("", "Column Filing Date. " + innerText);
          this.ColumnFilingDate(innerText);
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          this.ColumnDacDocument(file, openInstructions);
          //wi responsiveVoiceSpeak("", "Column DAC Document. " + innerText);
        }
        if (event.target.id == "tdFilingCertificates") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
          this.ColumnFilingCertificates(innerText);
          //responsiveVoiceSpeak("", "Column Filing Certificates. " + innerText + " Please contact your Client Service manager to obtain the document.");
        }
        if (event.target.id == "tdDaysLate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[5].innerText;
          this.ColumnDaysLate(innerText);
          // responsiveVoiceSpeak("", "Column Days Late. " + innerText);
        }
        if (event.target.id == "tdFindings") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[6].innerText;
          this.ColumnFindings(innerText);
          //responsiveVoiceSpeak("", "Column Findings. " + innerText);
        }
        if (event.target.id == "tdComments") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Comments. Not available.");
          }
          else {
            responsiveVoiceSpeak("", "Column Comments. " + innerText + ".");
          }
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDescFillingH") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;

          this.ColumnDescription(innerText, "Column Document Description. ");
          //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
        }
        if (event.target.id == "tdDueDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDueDate(innerText);
          //responsiveVoiceSpeak("", "Column Due Date. " + innerText);
        }
        if (event.target.id == "tdFindingsFilingDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          this.ColumnFilingDate(innerText);
          //responsiveVoiceSpeak("", "Column Filing Date. " + innerText);
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          this.ColumnDacDocument(file, openInstructions);
          //responsiveVoiceSpeak("", "Column DAC Document. " + innerText);
        }
        if (event.target.id == "tdFilingCertificates") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
          this.ColumnFilingCertificates(innerText);
          //responsiveVoiceSpeak("", "Column Filing Certificates. " + innerText + " Please contact your Client Service manager to obtain the document.");
        }
        if (event.target.id == "tdDaysLate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[5].innerText;
          this.ColumnDaysLate(innerText);
          //responsiveVoiceSpeak("", "Column Days Late. " + innerText);
        }
        if (event.target.id == "tdFindings") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[6].innerText;
          this.ColumnFindings(innerText);
          //responsiveVoiceSpeak("", "Column Findings. " + innerText);
        }
        if (event.target.id == "tdComments") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[6].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Comments. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Comments. " + innerText + ". This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Comments. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Comments. " + innerText + ". This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;

      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tddocumentDescFillingH") {//tddocumentDesc
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDueDate") {
            this.ColumnDueDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Due Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDueDate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFindingsFilingDate") {
            this.ColumnFilingDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFindingsFilingDate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLink") {
            this.ColumnDacDocument(file, openInstructions);
            //responsiveVoiceSpeak("", "Column DAC Document. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDocumentLink") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingCertificates") {
            this.ColumnFilingCertificates(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Certificates. " + target[0].innerText + " Please contact your Client Service manager to obtain the document.");
          }
        }
        if (event.target.id == "tdFilingCertificates") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDaysLate") {
            this.ColumnDaysLate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Days Late. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDaysLate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFindings") {
            this.ColumnFindings(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Findings. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFindings") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdComments") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Comments. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Comments. " + target[0].innerText + ". This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Comments. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Comments. " + target[0].innerText + ". This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        if (event.target.id == "tdComments") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdComments") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              //this.ColumnDescription(target[0].innerText);
              this.ColumnDescription(target[0].innerText, "Column Document Description. ");
              //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
            }
          }
        }
      }
      else if (event.keyCode == 37) {
        if (event.target.id == "tdFilingCertificates") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLink") {
            this.ColumnDacDocument(file, openInstructions);
            //responsiveVoiceSpeak("", "Column DAC Document. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFindingsFilingDate") {
            this.ColumnFilingDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFindingsFilingDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDueDate") {
            this.ColumnDueDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Due Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDueDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDescFillingH") {

            this.ColumnDescription(target[0].innerText, "Column Document Description. ");
            // responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdComments") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFindings") {
            this.ColumnFindings(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Findings. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFindings") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDaysLate") {
            this.ColumnDaysLate(target[0].innerText);
            // responsiveVoiceSpeak("", "Column Days Late. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDaysLate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingCertificates") {
            this.ColumnFilingCertificates(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Filing Certificates. " + target[0].innerText + " Please contact your Client Service manager to obtain the document.");
          }
        }
        if (event.target.id == "tddocumentDescFillingH") {
          $(event.target).parent().prev().children("td").eq(7).focus();
          if (event.target.id == "tddocumentDesc") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[7].innerText;
              if (innerText == "") {
                responsiveVoiceSpeak("", "Column Comments. Not available.");
              }
              else {
                responsiveVoiceSpeak("", "Column Comments. " + innerText + ".");
              }
            }
          }
        }
      }
    }
  }
  // Documentation Table
  onKeyUpDocumentation(event: any, file: any) {
    debugger;

    let openInstructions = makeOpenInstructions(file);

    if (event.keyCode != 17) {

      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }

      // shift + tab functionality
      if ((event.target.id == "tdIssuerRequest" || event.target.id == "tddocumentDesc" || event.target.id == "tdDocDate" || event.target.id == "tdFirm" || event.target.id == "tdDocumentLink") && event.keyCode == 16) {
        document.getElementById("tabDocumentation").focus();
        return;
      }

      if (event.target.id == "tddocumentDesc" && event.keyCode == 9) {
        responsiveVoiceSpeak("", "Column Document Description. " + event.target.innerText + ". Use right arrow key to go to next column.");
      }

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          this.ColumnDescription(innerText, "Column Document Description. ");
          //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
        }
        if (event.target.id == "tdDocDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDocDate(innerText);
          // responsiveVoiceSpeak("", "Column Doc Date. " + innerText);
        }
        if (event.target.id == "tdFirm") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          responsiveVoiceSpeak("", "Column Firm. " + innerText + ". Use right arrow key to go to next column.");
        }
        if (event.target.id == "tdIssuerRequest") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          responsiveVoiceSpeak("", "Column Issuer Request. " + innerText + ". Use right arrow key to go to next column.");
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Document. Not available. This is the last column. Use side arrow key to go to the next row.");
          }
          else {
            responsiveVoiceSpeak("", "Column Document. " + openInstructions + "  This is the last column. Use side arrow key to go to the next row.");
          }
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          this.ColumnDescription(innerText, "Column Document Description. ");
        }
        if (event.target.id == "tdDocDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          this.ColumnDocDate(innerText);
        }
        if (event.target.id == "tdFirm") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          responsiveVoiceSpeak("", "Column Firm. " + innerText + ". Use right arrow key to go to next column.");
        }
        if (event.target.id == "tdIssuerRequest") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          responsiveVoiceSpeak("", "Column Issuer Request. " + innerText + ". Use right arrow key to go to next column.");
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Document. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Document. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;
      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tddocumentDesc") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocDate") {
            this.ColumnDocDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Doc Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDocDate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFirm") {
            responsiveVoiceSpeak("", "Column Firm. " + target[0].innerText + ". Use right arrow key to go to next column.");
            // responsiveVoiceSpeak("", "Column Firm. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdFirm") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdIssuerRequest") {
            responsiveVoiceSpeak("", "Column Issuer Request. " + target[0].innerText + ". Use right arrow key to go to next column.");
            //responsiveVoiceSpeak("", "Column Issuer Request. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdIssuerRequest") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLink") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Document. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Document. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        if (event.target.id == "tdDocumentLink") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdDocumentLink") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              this.ColumnDescription(innerText);
              //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
            }
          }
        }
      }
      else if (event.keyCode == 37) {
        if (event.target.id == "tdDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdIssuerRequest") {
            responsiveVoiceSpeak("", "Column Issuer Request. " + target[0].innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdIssuerRequest") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdFirm") {

            responsiveVoiceSpeak("", "Column Firm. " + target[0].innerText + ". Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdFirm") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDocDate") {
            this.ColumnDocDate(target[0].innerText);
            //responsiveVoiceSpeak("", "Column Doc Date. " + target[0].innerText);
          }
        }
        if (event.target.id == "tdDocDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDesc") {
            this.ColumnDescription(target[0].innerText, "Column Document Description. ");
            // responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText);
          }
        }
        if (event.target.id == "tddocumentDesc") {
          $(event.target).parent().prev().children("td").eq(4).focus();
          if (event.target.id == "tddocumentDesc") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
              if (innerText == "") {
                responsiveVoiceSpeak("", "Column Document. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Document. " + openInstructions + " This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
      }
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
    }
  }
  // Policies & Procedures Table
  onKeyUpPoliciesAndProcedures(event: any) {
    debugger;

    if (event.target.id == "tdCDA" && event.keyCode == 13) {
      this.showFilingRequirements();
      return;
    }
    if (event.keyCode != 17) {

      if ((event.target.id == "tddocumentDesc" || event.target.id == "tdDocumentLink" || event.target.id == "tdCDA" || event.target.id == "tdCusips" || event.target.id == "tdDate") && event.keyCode == 16) {
        document.getElementById("tabPoliciesAndProcedures").focus();
        return;

      }

      if (event.target.id == "tddocumentDesc" && event.keyCode == 9) {
        responsiveVoiceSpeak("", "Column Document Description. " + event.target.innerText + ". Use right arrow key to go to next column. ");
      }

      if (event.target.id == "tdCusips" && event.keyCode == 13) {
        this.router.navigate(['/pandpcusip']);
      }

      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          responsiveVoiceSpeak("", "Column Document Description. " + innerText + ". Use right arrow key to go to next column. ");
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          responsiveVoiceSpeak("", "Column Document. " + innerText + ". Use right arrow key to go to next column. ");
        }
        if (event.target.id == "tdCDA") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column CDA. Not available." + " Use right arrow key to go to next column. ");
          }
          else {
            responsiveVoiceSpeak("", "Column CDA. " + innerText + ". Use right arrow key to go to next column. ");
          }
        }
        if (event.target.id == "tdCusips") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Cusips. Not available." + " Use right arrow key to go to next column. ");
          }
          else {
            responsiveVoiceSpeak("", "Column Cusips. " + innerText + ". Use right arrow key to go to next column. ");
          }
        }
        if (event.target.id == "tdDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Date. Not available.");
          }
          else {
            responsiveVoiceSpeak("", "Column Date. " + innerText + ". This is the last column. Use side arrow key to go to the next row.");
          }
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          responsiveVoiceSpeak("", "Column Document Description. " + innerText + ". Use right arrow key to go to next column. ");
        }
        if (event.target.id == "tdDocumentLink") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          responsiveVoiceSpeak("", "Column Document. " + innerText + ". Use right arrow key to go to next column. ");
        }
        if (event.target.id == "tdCDA") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column CDA. Not available." + ". Use right arrow key to go to next column. ");
          }
          else {
            responsiveVoiceSpeak("", "Column CDA. " + innerText + ". Use right arrow key to go to next column. ");
          }
        }
        if (event.target.id == "tdCusips") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          if (innerText == "") {
            responsiveVoiceSpeak("", "Column Cusips. Not available." + ". Use right arrow key to go to next column. ");
          }
          else {
            responsiveVoiceSpeak("", "Column Cusips. " + innerText + ". Use right arrow key to go to next column. ");
          }
        }
        if (event.target.id == "tdDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[4].innerText;
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Date. Not available. This is the last row and the last column. Use escape to go to the footer.");
            }
            else {
              responsiveVoiceSpeak("", "Column Date. " + innerText + ". This is the last row and the last column. Use escape to go to the footer.");
            }
          }
          else {
            if (innerText == "") {
              responsiveVoiceSpeak("", "Column Date. Not available. This is the last column. Use side arrow key to go to the next row.");
            }
            else {
              responsiveVoiceSpeak("", "Column Date. " + innerText + ". This is the last column. Use side arrow key to go to the next row.");
            }
          }
        }
        return;
      }
      else if (event.keyCode == 39) {
        var child_cell = $(event.target).index();
        if (event.target.id == "tddocumentDesc") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLink") {
            responsiveVoiceSpeak("", "Column Document. " + target[0].innerText + ". Use right arrow key to go to next column. ");
          }
        }
        if (event.target.id == "tdDocumentLink") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdCDA") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column CDA. Not available." + " Use right arrow key to go to next column. ");
            }
            else {
              responsiveVoiceSpeak("", "Column CDA. " + target[0].innerText + ". Use right arrow key to go to next column. ");
            }
          }
        }
        if (event.target.id == "tdCDA") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdCusips") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Cusips. Not available." + " Use right arrow key to go to next column. ");
            }
            else {
              responsiveVoiceSpeak("", "Column Cusips. " + target[0].innerText + ". Use right arrow key to go to next column. ");
            }
          }
        }
        if (event.target.id == "tdCusips") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDate") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Date. Not available. This is the last row and the last column. Use escape to go to the footer.");
              }
              else {
                responsiveVoiceSpeak("", "Column Date. " + target[0].innerText + ". This is the last row and the last column. Use escape to go to the footer.");
              }
            }
            else {
              if (target[0].innerText == "") {
                responsiveVoiceSpeak("", "Column Date. Not available. This is the last column. Use side arrow key to go to the next row.");
              }
              else {
                responsiveVoiceSpeak("", "Column Date. " + target[0].innerText + ". This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
        if (event.target.id == "tdDate") {
          $(event.target).parent().next().children("td").eq(0).focus();
          if (event.target.id == "tdDate") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              this.ColumnDescription(innerText, "Column Document Description. ");
              //responsiveVoiceSpeak("", "Column Document Description. " + innerText);
            }
          }
        }
      }
      else if (event.keyCode == 37) {
        if (event.target.id == "tdDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdCusips") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column Cusips. Not available." + " Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column Cusips. " + target[0].innerText + " Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdCusips") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdCDA") {
            if (target[0].innerText == "") {
              responsiveVoiceSpeak("", "Column CDA. Not available." + " Use right arrow key to go to next column.");
            }
            else {
              responsiveVoiceSpeak("", "Column CDA. " + target[0].innerText + " Use right arrow key to go to next column.");
            }
          }
        }
        if (event.target.id == "tdCDA") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDocumentLink") {
            responsiveVoiceSpeak("", "Column Document. " + target[0].innerText + " Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tdDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDesc") {
            responsiveVoiceSpeak("", "Column Document Description. " + target[0].innerText + " Use right arrow key to go to next column.");
          }
        }
        if (event.target.id == "tddocumentDesc") {
          $(event.target).parent().prev().children("td").eq(4).focus();
          if (event.target.id == "tddocumentDesc") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[4].innerText;
              if (innerText == "") {
                responsiveVoiceSpeak("", "Column Date. Not available.");
              }
              else {
                responsiveVoiceSpeak("", "Column Date. " + innerText + ". This is the last column. Use side arrow key to go to the next row.");
              }
            }
          }
        }
      }
      if (event.keyCode == 27) {
        document.getElementById("SkipMainContentfooter").focus();
        BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
    }
  }

  onKeydown(event) {
    debugger;
    if (event.target.id == "tabOverview" && event.keyCode == 13) {
      document.getElementById("lblTableCounttabOverview").focus();
      if (this.TableCounttabOverview > "0") {
        responsiveVoiceSpeak("", "" + this.TableCounttabOverview + " number of tables found. Use tab to go to the next field.");
      }
      if (this.TableCounttabOverview == "0") {
        responsiveVoiceSpeak("", "No data available.  Use shift and tab to change the section or use escape key to go to footer.");
      }
    }
    if (event.target.id == "tabFilingRequirements" && event.keyCode == 13) {
      document.getElementById("lblFilingTableCounttabOverview").focus();
      if (this.TableFilingCounttabOverview > "0") {
        responsiveVoiceSpeak("", "" + this.TableFilingCounttabOverview + " number of tables found. Use tab to go to the next field.");
      }
      if (this.TableFilingCounttabOverview == "0") {
        responsiveVoiceSpeak("", "No data available.  Use shift and tab to change the section or use escape key to go to footer.");
      }
    }
    if (event.target.id == "tabTemplates" && event.keyCode == 13) {
          document.getElementById("lblTemplatesTableCoulmnCount").focus();
          responsiveVoiceSpeak("", this.CounTableRows(this.ComplianceTemplatesArray) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use tab to go to the table.");
      }
    if (event.target.id == "tabPoliciesAndProcedures" && event.keyCode == 13) {
          document.getElementById("lblPoliciesAndProceduresTableCoulmnCount").focus();
          responsiveVoiceSpeak("", this.CounTableRows(this.IssuerCTPoliciesAndProceduresArray) + " There are five columns in this table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use tab to go to the table.");
      }
    if (event.target.id == "tabDocumentation" && event.keyCode == 13) {
          document.getElementById("lblDocumentationTableCoulmnCount").focus();
          responsiveVoiceSpeak("", this.CounTableRows(this.IssuerCTDocumentationArray) + " There are five columns in the documentation table. Use up-down and left-right arrow keys to navigate the table. At any time, use shift and tab to change the section or use escape key to exit the table and go to footer. Use tab to go to the table.");
      }
    if (event.target.id == "tabFilingHistory" && event.keyCode == 13) {
      document.getElementById("lblFilingHistoryTableCounttabOverview").focus();
      if (this.TableFilingHistoryCounttabOverview > "0") {
        responsiveVoiceSpeak("", "" + this.TableFilingHistoryCounttabOverview + " number of tables found. Use tab to go to the next field.");
      }
      if (this.TableFilingHistoryCounttabOverview == "0") {
        responsiveVoiceSpeak("", "No data available.  Use shift and tab to change the section or use escape key to go to footer.");
      }
    }

    if (event.target.id == "tabFindings" && event.keyCode == 13) {
      document.getElementById("lblFindingsTableCount").focus();
      if (this.TableFindingsCounttabOverview > "0") {
        responsiveVoiceSpeak("", "" + this.TableFindingsCounttabOverview + " number of tables found. Use tab to go to the next field.");
      }
      if (this.TableFindingsCounttabOverview == "0") {
        responsiveVoiceSpeak("", "No data available.  Use shift and tab to change the section or use escape key to go to footer.");
      }
    }
  }

  onKeyUpDocument(event: any, file) {
    if (event.keyCode == 13) {
      this.showTemplateModal(file, event);
      //this.showModal(file);
    }
  }

  showModal(file) {
    debugger;
    if (file != null) {
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      window.open(file.documentLink + "&inline=1", "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
    }
  }

  showTemplateModal(file, event: any) {
    debugger;
    let fileDescription = makeFileDescription(file);
    $("#hdtblid").val($(event.target).parents("table").attr("id"));
    $("#hdRowsIndex").val($(event.target).parents("tr").index());
    this.TemplateFileDocumentLink = file.documentLink;
    if (fileDescription == "Microsoft Word document" || fileDescription == "Spreadsheet document" || fileDescription == "Word processing document" || fileDescription == "Microsoft Excel document") {
      var tabId = $(event.target).parents("table").attr("id");
      if (tabId == "tblTemplateArray") {
        document.getElementById('webinarDiv').style.display = "block";
        $("#divwebcastVideo").focus();
        $("#hdextensiontype").val("Excel");
        responsiveVoiceSpeak("", "Disclaimer.");
      }
      else {
        this.DownloadTemplateFile(event);
      }

    }
    else {
      $("#hdextensiontype").val("Pdf");
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      window.open(file.documentLink + '&inline=1', "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
    }
  }

  DownloadTemplateFile(event: any) {
    debugger
    this.downloadStatus = "";
    var TemplateFileDocumentLinkURL;
    var rowsindex = 0;
    var extension = $("#hdextensiontype").val();
    if ($("#hdtblid").val() == "tblTemplateArray") {
      TemplateFileDocumentLinkURL = this.TemplateFileDocumentLink;
      window.open(TemplateFileDocumentLinkURL + "&termsOfUseAccepted=true");
      responsiveVoiceSpeak("", "File is downloading. ");
      //this.loadTemplateFile(TemplateFileDocumentLinkURL +"&termsOfUseAccepted=true");
      //if (this.downloadStatus == "1") {
      //  responsiveVoiceSpeak("", "File is downloading. ");
      //}
      //else {
      //  responsiveVoiceSpeak("", "Unable to downlaod a file. ");
      //}
    }
    else {

      TemplateFileDocumentLinkURL = this.TemplateFileDocumentLink;
      responsiveVoiceSpeak("", "File is downloading. ");
      window.open(TemplateFileDocumentLinkURL);
      //window.opener.parent.focus();
      //window.location.assign(TemplateFileDocumentLinkURL);

    }

    rowsindex = $("#hdRowsIndex").val();
    document.getElementById('webinarDiv').style.display = "none";
    responsiveVoiceSpeak("", "Column Document. Press enter to download the document. This is the last column. Use side arrow key to go to the next row.");
    // $('#tblTemplateArray tr:gt(0)').eq(rowsindex).find('td').eq(4).click();
    var tableId = $("#hdtblid").val();
    var Ids = '#' + tableId + ' tr:gt(0)';
    $(Ids).eq(rowsindex).find('td').eq(4).focus();

    return;
  }

  ClsoeTemplatePopup(event: any) {
    debugger
    var rowsindex = $("#hdRowsIndex").val();
    document.getElementById('webinarDiv').style.display = "none";
    responsiveVoiceSpeak("", "Column Document. Press enter to download the document. This is the last column. Use side arrow key to go to the next row.");
    var tableId = $("#hdtblid").val();
    var Ids = '#' + tableId + ' tr:gt(0)';
    $(Ids).eq(rowsindex).find('td').eq(4).focus();
    return;
  }

  //DownloadTemplateFile() {
  //  var TemplateFileDocumentLinkURL = this.TemplateFileDocumentLink + "&termsOfUseAccepted=true";
  //  this.loadTemplateFile(TemplateFileDocumentLinkURL);
  //}

  showFilingRequirements() {
    responsiveVoiceSpeak("", "Filing requirements section. This section provides Issue description and CDA and Summary language related to the obligor. Use enter key to view the section or use tab to go to the next section.");
    document.getElementById("tabFilingRequirements").click();
    document.getElementById("tabFilingRequirements").focus();
  }

  ngOnInit() {
    // initialization tab index.
    this.GenericTabIndex = 200;
    this.GenericTabNextIndex = 0;
    this.GenericTabNextIndexN1 = 0;
    this.IssuesNoLongerIndex = 0;
    this.GenericTabIndexN1 = 200;

    // Get OBLIGOR_ID from local Storage.
    var OBLIGOR_ID = localStorage.getItem("OBLIGOR_ID");
    debugger;
    // Hide all authorized Obligor Tabs and Then Show on the basis of API CTAuthorizations as below loadCTAuthorizations.
    this.ActiveDislay();
    this.loadCTAuthorizations(OBLIGOR_ID);
    this.loadComplianceOverview(OBLIGOR_ID);
    this.loadFiscalYearEnd(OBLIGOR_ID);
    this.loadIncurrenceDate(OBLIGOR_ID);
    this.loadFilingRequirements(OBLIGOR_ID);
    this.loadComplianceTemplates(OBLIGOR_ID);
    this.loadComplianceFilingHistory(OBLIGOR_ID);
    this.loadComplianceReviewFindings(OBLIGOR_ID);
    this.loadIssuerCTDocumentation(OBLIGOR_ID);
    this.loadIssuerCTPoliciesAndProcedures(OBLIGOR_ID);
    this.loadIssuerCTCUSIPs(OBLIGOR_ID);
    this.loadDefaultEmailBody();
//=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }

    this.MagnifieronDynamicChecking();
        
    document.getElementById("divSendEmailSuccess").style.display = 'none';
    $('#sendEmail').on('shown.bs.modal', function (event) {
      debugger;
      $('#lblSendtoEmailAddress').focus();
    });
  }

  ngOnDestroy() {
    debugger
    localStorage.removeItem("PPC");
  }
  MagnifieronDynamicChecking() {
    FontSizeSettings();
  }

  // to open mail popup 
  onMailpopupOpen(event: any) {
    debugger
    $("#hdtblid").val($(event.target).parents("table").attr("id"));
    $("#hdRowsIndex").val($(event.target).parents("tr").index());
    $("#sendEmail").modal('show');
    $('#lblSendtoEmailAddress').focus();
    return;
  }
  ngAfterViewInit() {

    // set tab focus
    if (localStorage.getItem("PPC")) {
      let itemPandTab = localStorage.getItem("PPC");

      if (itemPandTab == "1") {
        document.getElementById("tabPoliciesAndProcedures").click();
        document.getElementById("tabPoliciesAndProcedures").focus();
        
      }
      if (itemPandTab == "2") {
        document.getElementById("tabFilingHistory").click();
        document.getElementById("tabFilingHistory").focus();
        
      }

      
    }
    // Set Magnifier button Enable/Disable
    if ($('#hdnMagnifierDisable').val() == "ENABLE") {
      $('#btnMagnify').val('ENABLE')
      MagnifierEnableDisable("ENABLE");
    }
    else {
      $('#btnMagnify').val('DISABLE')
      MagnifierEnableDisable("DISABLE");
    }
  }

  public ActiveDislay() {
    document.getElementById("tabOverview").style.display = "none";
    document.getElementById("tabFilingRequirements").style.display = "none";
    document.getElementById("tabTemplates").style.display = "none";
    document.getElementById("tabFilingHistory").style.display = "none";
    document.getElementById("tabFindings").style.display = "none";
    document.getElementById("tabDocumentation").style.display = "none";
    document.getElementById("tabPoliciesAndProcedures").style.display = "none";
  }

  MaildocumentLink(documentLink) {
    this.SendMaildocumentLink = documentLink;
    (<HTMLTextAreaElement>document.getElementById("txtEmailBody")).value = this.IssuerDefaultEmailBody;
    document.getElementById("divSendEmailSuccess").style.display = 'none';
  }

  EmailDocument() {
    debugger;
    document.getElementById("divSendEmailSuccess").innerHTML = "";
    var recipientAddresses = <HTMLTextAreaElement>document.getElementById("txtEmailIds");
    var introductionText = <HTMLTextAreaElement>document.getElementById("txtEmailBody");

    if (recipientAddresses.value == "") {
      responsiveVoiceSpeak("", "Please enter an email.");
      $("#divSendEmailSuccess").addClass("alert alert-danger");
      document.getElementById("divSendEmailSuccess").style.display = "block"
      document.getElementById("divSendEmailSuccess").innerHTML = "Please enter an email.";
      recipientAddresses.focus();
      return;
    }

    var eml = recipientAddresses.value.split(/\s*,\s*/).filter(e => e != "");
    // to validate email
    let IsEmail = true;
    for (var i = 0; i < eml.length; i++) {
      var email = eml[i];
      if (!ValidateEmail(email)) {
        IsEmail = false;
      }
    }

    if (!IsEmail) {
      responsiveVoiceSpeak("", "Please enter a valid email.");
      recipientAddresses.focus();
      $("#divSendEmailSuccess").addClass("alert alert-danger");
      document.getElementById("divSendEmailSuccess").style.display = "block"
      document.getElementById("divSendEmailSuccess").innerHTML = "Please enter a valid email. ";
      return;
    }
    document.getElementById("divSendEmailSuccess").style.display = 'none';
    this.IssuerEmailCDADocumentLink(localStorage.getItem("OBLIGOR_ID"), this.SendMaildocumentLink, recipientAddresses.value.split(/\s*,\s*/).filter(e => e != ""), introductionText.value);

  }

   FormatByteToKB(fileSizeBytes) {
    if (fileSizeBytes == null) {
      return "";
    }
    else {
      return formatBytes(fileSizeBytes, 1);
    }
  }

  MakeFileDescription(file: any) {
    return makeFileDescription(file);
  }

  SetDocumentFileImage(mimeType) {
    var DomainURL = environment.apiUrl;
    var DomainURLForDocImage = DomainURL.replace("api", "framework");
    if (mimeType == null) {
      var DocumentImageUrl = DomainURLForDocImage + "images/Icons/mimetypes/" + "application/pdf" + ".gif";
      return DocumentImageUrl;
    }
    else {
      var DocumentImageUrl = DomainURLForDocImage + "images/Icons/mimetypes/" + mimeType + ".gif";
      return DocumentImageUrl;
    }
  }

  SetPDFFileImage(documentLink) {
    if (documentLink == null) {
      return "";
    }
    else {
      var DomainURL = environment.apiUrl;
      var DomainURLForDocImage = DomainURL.replace("api", "framework");
      var DocumentImageUrl = DomainURLForDocImage + "images/Icons/mimetypes/" + "application/pdf" + ".gif";
      return DocumentImageUrl;
    }
  }

  showValidTab(event: any) {
    debugger;
    document.getElementById("SkipMainContentfooter").tabIndex = 80;
    if (event.target.id == "tabOverview") {
      document.getElementById("OverviewTab").style.display = "block";
      document.getElementById("FilingRequirementsTab").style.display = "none";
      document.getElementById("TemplatesTab").style.display = "none";
      document.getElementById("FilingHistoryTab").style.display = "none";
      document.getElementById("FindingsTab").style.display = "none";
      document.getElementById("DocumentationTab").style.display = "none";
      document.getElementById("PoliciesAndProceduresTab").style.display = "none";

      //if (this.TableCounttabOverview == "2") {
      //  document.getElementById("SkipMainContentfooter").tabIndex = 153;
      //  document.getElementById("PageDMCA").tabIndex = 154;
      //  document.getElementById("footer").tabIndex = 155;
      //  document.getElementById("contactNo").tabIndex = 156;
      //  document.getElementById("AboutUsPageTab").tabIndex = 156;
      //  document.getElementById("helpPage").tabIndex = 157;
      //  document.getElementById("SiteMap").tabIndex = 158;
      //}


    }
    if (event.target.id == "tabFilingRequirements") {
      document.getElementById("OverviewTab").style.display = "none";
      document.getElementById("FilingRequirementsTab").style.display = "block";
      document.getElementById("TemplatesTab").style.display = "none";
      document.getElementById("FilingHistoryTab").style.display = "none";
      document.getElementById("FindingsTab").style.display = "none";
      document.getElementById("DocumentationTab").style.display = "none";
      document.getElementById("PoliciesAndProceduresTab").style.display = "none";

      //if (this.TableFilingCounttabOverview == "2") {
      //  document.getElementById("SkipMainContentfooter").tabIndex = 157;
      //  document.getElementById("PageDMCA").tabIndex = 158;
      //  document.getElementById("footer").tabIndex = 159;
      //  document.getElementById("contactNo").tabIndex = 160;
      //  document.getElementById("AboutUsPageTab").tabIndex = 161;
      //  document.getElementById("helpPage").tabIndex = 162;
      //  document.getElementById("SiteMap").tabIndex = 163;
      //}

    }
    if (event.target.id == "tabTemplates") {
      document.getElementById("OverviewTab").style.display = "none";
      document.getElementById("FilingRequirementsTab").style.display = "none";
      document.getElementById("TemplatesTab").style.display = "block";
      document.getElementById("FilingHistoryTab").style.display = "none";
      document.getElementById("FindingsTab").style.display = "none";
      document.getElementById("DocumentationTab").style.display = "none";
      document.getElementById("PoliciesAndProceduresTab").style.display = "none";
    }
    if (event.target.id == "tabFilingHistory") {
      document.getElementById("OverviewTab").style.display = "none";
      document.getElementById("FilingRequirementsTab").style.display = "none";
      document.getElementById("TemplatesTab").style.display = "none";
      document.getElementById("FilingHistoryTab").style.display = "block";
      document.getElementById("FindingsTab").style.display = "none";
      document.getElementById("DocumentationTab").style.display = "none";
      document.getElementById("PoliciesAndProceduresTab").style.display = "none";
    }
    if (event.target.id == "tabFindings") {
      document.getElementById("SkipMainContentfooter").tabIndex = 176;
      document.getElementById("OverviewTab").style.display = "none";
      document.getElementById("FilingRequirementsTab").style.display = "none";
      document.getElementById("TemplatesTab").style.display = "none";
      document.getElementById("FilingHistoryTab").style.display = "none";
      document.getElementById("FindingsTab").style.display = "block";
      document.getElementById("DocumentationTab").style.display = "none";
      document.getElementById("PoliciesAndProceduresTab").style.display = "none";
    }
    if (event.target.id == "tabDocumentation") {
      document.getElementById("OverviewTab").style.display = "none";
      document.getElementById("FilingRequirementsTab").style.display = "none";
      document.getElementById("TemplatesTab").style.display = "none";
      document.getElementById("FilingHistoryTab").style.display = "none";
      document.getElementById("FindingsTab").style.display = "none";
      document.getElementById("DocumentationTab").style.display = "block";
      document.getElementById("PoliciesAndProceduresTab").style.display = "none";
    }
    if (event.target.id == "tabPoliciesAndProcedures") {
      document.getElementById("OverviewTab").style.display = "none";
      document.getElementById("FilingRequirementsTab").style.display = "none";
      document.getElementById("TemplatesTab").style.display = "none";
      document.getElementById("FilingHistoryTab").style.display = "none";
      document.getElementById("FindingsTab").style.display = "none";
      document.getElementById("DocumentationTab").style.display = "none";
      document.getElementById("PoliciesAndProceduresTab").style.display = "block";
    }
  }

  //=======================Call all API for compliance-review screen=================//

  loadCTAuthorizations(obligorId: string) {
    debugger;
    this.issuerAPIService.GetCTAuthorizations(obligorId).subscribe(data => {
      
      if (data["obligor"]["authorizedObligorTabs"].length > 0) {
        this.TabSectionsCount = data["obligor"]["authorizedObligorTabs"].length.toString();
        document.getElementById("divOverview").style.display = "block";
        for (var i = 0; i < data["obligor"]["authorizedObligorTabs"].length; i++) {
          var authorizedTabs = data["obligor"]["authorizedObligorTabs"][i];
          if (authorizedTabs == "OVERVIEW") {
            document.getElementById("tabOverview").style.display = "block";
            //document.getElementById("OverviewTab").style.display = "block";
          }
          if (authorizedTabs == "CDAS") {
            document.getElementById("tabFilingRequirements").style.display = "block";
          }
          if (authorizedTabs == "TEMPLATES") {
            document.getElementById("tabTemplates").style.display = "block";
          }
          if (authorizedTabs == "FILING_HISTORY") {
            document.getElementById("tabFilingHistory").style.display = "block";
          }
          if (authorizedTabs == "FINDINGS") {
            document.getElementById("tabFindings").style.display = "block";
          }
          if (authorizedTabs == "DOCUMENTATION") {
            document.getElementById("tabDocumentation").style.display = "block";
          }
          if (authorizedTabs == "POLICIES_PROCEDURES") {
            document.getElementById("tabPoliciesAndProcedures").style.display = "block";
          }
        }
        // SET Active Tab
        debugger
        var authorizedSelectedTab = data["obligor"]["authorizedObligorTabs"][0];
        if (authorizedSelectedTab == "OVERVIEW") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabOverview").click();
          }
        }
        else if (authorizedSelectedTab == "CDAS") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabFilingRequirements").click();
          }
          
        }
        else if (authorizedSelectedTab == "TEMPLATES") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabTemplates").click();
          }
          
        }
        else if (authorizedSelectedTab == "FILING_HISTORY") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabFilingHistory").click();
          }

        }
        else if (authorizedSelectedTab == "FINDINGS") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabFindings").click();
          }
          
        }
        else if (authorizedSelectedTab == "DOCUMENTATION") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabDocumentation").click();
          }
         
        }
        else if (authorizedSelectedTab == "POLICIES_PROCEDURES") {
          if (!localStorage.getItem("PPC")) {
            document.getElementById("tabPoliciesAndProcedures").click();
          }
          
        }
        // set tab focus
        if (localStorage.getItem("PPC")) {
          let ppcvalue = localStorage.getItem("PPC");
          if (ppcvalue == "1") {
            document.getElementById("tabPoliciesAndProcedures").focus();
            responsiveVoiceSpeak("", "Policies and procedures section. This provides information of Policies and Procedure documents. Use enter key to view the section or use tab to go to the footer.");
          }
          else if (ppcvalue == "2") {
            document.getElementById("tabFilingHistory").focus();
            responsiveVoiceSpeak("", "Filing History section. This section provides information of filings of every category and list of all 9 digit Cusips. Use enter key to view the section or use tab to go to the next section.");
          }
        }
        
      }
    });
  }

  loadComplianceOverview(obligorId: string) {
    debugger;
    responsiveVoiceSpeak("", "Please wait while the page is loading.");
    document.getElementById("overlay").style.display = "block";
    this.issuerAPIService.GetComplianceOverview(obligorId).subscribe(data => {
      document.getElementById("overlay").style.display = "none";
      responsiveVoiceSpeak("", "This is Compliance toolkit page. Use tab to go to the next field.");
      debugger;
      var countactiveInactiveBonds = 0;
      if (typeof data["activeBonds"] != "undefined") {
        if (data["activeBonds"].length > 0) {
          this.ActiveBondsComplianceOverviewArray = data["activeBonds"];
          countactiveInactiveBonds = countactiveInactiveBonds + 1;
          this.IssuesNoLongerIndex = this.GenericTabIndex + data["activeBonds"].length + 1;
          // count no. of rows in table in file object to set table rows
          var objData = data["activeBonds"];
          for (var i = 0; i < objData.length; i++) {
            if (objData[i].files != null) {
              if (objData[i].files.length > 0) {
                this.OverViewCurrentIssueRows = objData[i].files.length + this.OverViewCurrentIssueRows;
              }
              else {
                this.OverViewCurrentIssueRows = this.OverViewCurrentIssueRows + 1;
              }
            }
            else {
              this.OverViewCurrentIssueRows = this.OverViewCurrentIssueRows + 1;
            }
          }

        }
        else {
          this.ActiveBondsComplianceOverviewArray = data["activeBonds"];
          countactiveInactiveBonds = countactiveInactiveBonds + 1;
          this.IssuesNoLongerIndex = this.GenericTabIndex + data["activeBonds"].length + 1;
        }

        console.log("current issue rows " + this.OverViewCurrentIssueRows);
      }
      else {

        this.ActiveBondsComplianceOverviewArray = undefined;
        countactiveInactiveBonds = countactiveInactiveBonds + 1;
        this.IssuesNoLongerIndex = this.GenericTabIndex + 1;
                
      }
      if (typeof data["inactiveBonds"] != "undefined") {
        if (data["inactiveBonds"].length > 0) {
          this.InActiveBondsComplianceOverviewArray = data["inactiveBonds"];
          countactiveInactiveBonds = countactiveInactiveBonds + 1;
          this.GenericTabNextIndex = this.IssuesNoLongerIndex + 1;
          // count no. of rows in table in file object to set table rows
          var objData = data["inactiveBonds"];
          for (var i = 0; i < objData.length; i++) {
            if (objData[i].files != null) {
              if (objData[i].files.length > 0) {
                this.OverViewNoIssueRows = objData[i].files.length + this.OverViewNoIssueRows;
              }
              else {
                this.OverViewNoIssueRows = this.OverViewNoIssueRows + 1;
              }
            }
            else {
              this.OverViewNoIssueRows = this.OverViewNoIssueRows + 1;
            }
          }
        }
        else {
          this.InActiveBondsComplianceOverviewArray = data["inactiveBonds"];
          countactiveInactiveBonds = countactiveInactiveBonds + 1;
          this.GenericTabNextIndex = this.IssuesNoLongerIndex + 1;
        }

        console.log("current issue rows " + this.OverViewNoIssueRows);
      }
      else {
        this.InActiveBondsComplianceOverviewArray = undefined;
        countactiveInactiveBonds = countactiveInactiveBonds + 1;
        this.GenericTabNextIndex = this.IssuesNoLongerIndex + 1;
                
      }
      this.TableCounttabOverview = countactiveInactiveBonds.toString();
    });

    //this.issuerAPIService.GetComplianceOverview(obligorId).subscribe(data => {
    //  document.getElementById("overlay").style.display = "none";
    //  responsiveVoiceSpeak("", "This is Compliance toolkit page. Use tab to go to the next field.");
    //  var countactiveInactiveBonds = 0;
    //  if (typeof data["activeBonds"] != "undefined") {
    //    if (data["activeBonds"].length > 0) {
    //      this.ActiveBondsComplianceOverviewArray = data["activeBonds"];
    //      countactiveInactiveBonds = countactiveInactiveBonds + 1;
    //      this.IssuesNoLongerIndex = this.GenericTabIndex + data["activeBonds"].length + 1;
    //    }
    //  }
    //  else {
    //    document.getElementById("divOverviewactiveBonds").style.display = "none";
    //    document.getElementById("hrOverviewactiveBonds").style.display = "none";
    //    document.getElementById("tblOverviewactiveBonds").style.display = "none";
    //  }
    //  if (typeof data["inactiveBonds"] != "undefined") {
    //    if (data["inactiveBonds"].length > 0) {
    //      this.InActiveBondsComplianceOverviewArray = data["inactiveBonds"];
    //      countactiveInactiveBonds = countactiveInactiveBonds + 1;
    //      this.GenericTabNextIndex = this.IssuesNoLongerIndex + 1;
    //    }
    //  }
    //  else {
    //    document.getElementById("divOverviewinactiveBonds").style.display = "none";
    //    document.getElementById("hrOverviewinactiveBonds").style.display = "none";
    //    document.getElementById("tblOverviewinactiveBonds").style.display = "none";
    //  }
    //  this.TableCounttabOverview = countactiveInactiveBonds.toString();
    //});
  }

  // Get Fiscal Year End
  loadFiscalYearEnd(obligorId: string) {
      this.issuerAPIService.GetFiscalYearEnd(obligorId).subscribe(data => {
          if (data == null) {
              this.FiscalYearEnd = "";
          }
          else if (data["length"] > 0) {
          this.FiscalYearEnd = data[0];
      }
    });
  }

  // Get Incurrence Date
  loadIncurrenceDate(obligorId: string) {
    this.issuerAPIService.GetIncurrenceDate(obligorId).subscribe(data => {
      debugger;
      if (data == null || data == undefined) {
        this.IncurrenceDate = "";
      }
      else if (data["length"] > 0) {
        this.IncurrenceDate = data[0];
      }
    });
  }

  // Get Default Email Body
  loadDefaultEmailBody() {
    debugger;
    // IssuerEmailBody(environment.apiUrl);
    this.issuerAPIService.GetDefaultEmailBody().subscribe(data => {
      debugger;
      this.IssuerDefaultEmailBody = "" + data; // JSON.stringify(data);
      // var introductionText = <HTMLTextAreaElement>document.getElementById("txtEmailBody");
      // introductionText.value = this.IssuerDefaultEmailBody;
    });
  }

  showEmailResult(success) {
    document.getElementById("divSendEmailSuccess").style.display = success ? 'block' : 'block';
    if (success) {
      $("#divSendEmailSuccess").addClass("alert alert-success");
      document.getElementById("divSendEmailSuccess").innerHTML = "Email sent successfully.Use enter to return back to the table.";
      ModelPopupMessage("Email sent successfully. Use enter to return back to the table.");
      responsiveVoiceSpeak("", "Email sent successfully.Use enter to return back to the table.");
  
    } else {
      $("#divSendEmailSuccess").addClass("alert alert-danger");
      document.getElementById("divSendEmailSuccess").innerHTML = "Unable to send email.";
      ModelPopupMessage("Unable to send email.");
      responsiveVoiceSpeak("", "Unable to send email.");
    }

    document.getElementById("CancelEmailDoc").focus();
    document.getElementById("CancelEmailDoc").tabIndex = 305;

  }

  // Send Issuer Email CDA Document Link
  IssuerEmailCDADocumentLink(obligorId: string, documentLink: string, recipientAddresses: any, introductionText: string) {

    this.issuerAPIService.SendIssuerEmailCDADocumentLink(obligorId, documentLink, recipientAddresses, introductionText).subscribe(
      data => {
        this.showEmailResult((data as any).success);
      }
      , error => {
        this.showEmailResult(false);
      },
    );
  }

  // Load Filing Requirements
  loadFilingRequirements(obligorId: string) {
    debugger;
    this.IssuesNoLongerIndexN1 = 0;
    //  no data found
    this.ActiveFilingRequirementsArray = undefined;
    this.InActiveFilingRequirementsArray = undefined;

    this.issuerAPIService.GetFilingRequirements(obligorId).subscribe(data => {
      debugger;
      var countactiveInactiveBonds = 0;
      var countDataTable = 0;
      for (var item in data) {
        if (item == "active") {
          var ActiveRows = 0;
          countactiveInactiveBonds = 0;
          var objData = data[item];
          var jsonObj = [];
          for (var i = 0; i < objData.length; i++) {
            var objrecords = {}
            objrecords["description"] = objData[i].description;
            objrecords["commencementDate"] = objData[i].commencementDate;
            var objDataDueDate = "";
            var j = 0;
            for (var item1 in objData[i].dueDates) {
              objDataDueDate += objData[i].dueDates[j].date + ",";
              j = j + 1;
            }
            if (objDataDueDate.length > 0) {
              objDataDueDate = objDataDueDate.replace(/,\s*$/, "");
            }
            //console.log(objDataDueDate)
            objrecords["dueDates"] = objDataDueDate;
            objrecords["files"] = objData[i].files;
            objrecords["isNar"] = objData[i].isNar;
            objrecords["bondLink"] = objData[i].bondLink;

            if (objData[i].files != null) {
              if (objData[i].files.length > 0) {
                ActiveRows = objData[i].files.length + ActiveRows;
              }
              else {
                ActiveRows = ActiveRows + 1
              }
            }
            else {
              ActiveRows = ActiveRows + 1
            }
            jsonObj.push(objrecords);
          }

          var productJSON2 = { "active": jsonObj };
          //console.log("RK "+ JSON.stringify(productJSON2))

          if (productJSON2["active"].length > 0) {
            this.ActiveFilingRequirementsArray = productJSON2["active"];
            countactiveInactiveBonds = countactiveInactiveBonds + 1;
            this.IssuesNoLongerIndexN1 = this.GenericTabIndexN1 + productJSON2["active"].length + 1;
          }

          else {

            this.ActiveFilingRequirementsArray = productJSON2["active"];
            countactiveInactiveBonds = countactiveInactiveBonds + 1;
            this.IssuesNoLongerIndexN1 = this.GenericTabIndexN1 + 1;
            //document.getElementById("hrFilingactive").style.display = "none";
            //document.getElementById("tblFilingactive").style.display = "none";
          }
          debugger

          this.activefilingRows = ActiveRows;
        
        }
        if (item == "inactive") {
          var inActiveRows = 0;
          var objData = data[item];
          var jsonObj = [];
          for (var i = 0; i < objData.length; i++) {
            var objrecords = {}
            objrecords["description"] = objData[i].description;
            objrecords["commencementDate"] = objData[i].commencementDate;
            var objDataDueDate = "";
            var j = 0;
            for (var item1 in objData[i].dueDates) {
              objDataDueDate += objData[i].dueDates[j].date + ",";
              j = j + 1;
            }
            if (objDataDueDate.length > 0) {
              objDataDueDate = objDataDueDate.replace(/,\s*$/, "");
            }
           // console.log(objDataDueDate)
            objrecords["dueDates"] = objDataDueDate;
            objrecords["files"] = objData[i].files;
            objrecords["isNar"] = objData[i].isNar;
            objrecords["bondLink"] = objData[i].bondLink;
            if (objData[i].files != null) {
              if (objData[i].files.length > 0) {
                inActiveRows = objData[i].files.length + inActiveRows;
              }
              else {
                inActiveRows = inActiveRows + 1;
              }
            }
            else {
              inActiveRows = inActiveRows + 1;
            }
            jsonObj.push(objrecords);
          }

          var productJSON1 = { "inactive": jsonObj };
          //console.log(JSON.stringify(productJSON1))

          if (productJSON1["inactive"].length > 0) {
            this.InActiveFilingRequirementsArray = productJSON1["inactive"];
            countactiveInactiveBonds = countactiveInactiveBonds + 1;
            this.GenericTabNextIndexN1 = this.IssuesNoLongerIndexN1 + 1;
          }

          else {
            this.InActiveFilingRequirementsArray = productJSON1["inactive"];
            countactiveInactiveBonds = countactiveInactiveBonds + 1;
            this.GenericTabNextIndexN1 = this.IssuesNoLongerIndexN1 + 1;

            //document.getElementById("divFilinginactive").style.display = "none";
            //document.getElementById("hrFilinginactive").style.display = "none";
            //document.getElementById("tblFilinginactive").style.display = "none";
          }
          debugger;
          this.inactivefilingRows = inActiveRows;

        }
      }
      this.TableFilingCounttabOverview = countactiveInactiveBonds.toString();


      //if (typeof data["active"] != "undefined") {
      //  if (data["active"].length > 0) {
      //    this.ActiveFilingRequirementsArray = data["active"];
      //    countactiveInactiveBonds = countactiveInactiveBonds + 1;
      //    this.IssuesNoLongerIndexN1 = this.GenericTabIndexN1 + data["active"].length + 1;
      //  }
      //}
      //else {
      //  document.getElementById("hrFilingactive").style.display = "none";
      //  document.getElementById("tblFilingactive").style.display = "none";
      //}
      //if (typeof data["inactive"] != "undefined") {
      //  if (data["inactive"].length > 0) {
      //    this.InActiveFilingRequirementsArray = data["inactive"];
      //    countactiveInactiveBonds = countactiveInactiveBonds + 1;
      //    this.GenericTabNextIndexN1 = this.IssuesNoLongerIndexN1 + 1;
      //  }
      //}
      //else {
      //  document.getElementById("divFilinginactive").style.display = "none";
      //  document.getElementById("hrFilinginactive").style.display = "none";
      //  document.getElementById("tblFilinginactive").style.display = "none";
      //}
      this.TableFilingCounttabOverview = countactiveInactiveBonds.toString();
    });
  }

  // Load Compliance Templates
  loadComplianceTemplates(obligorId: string) {
    debugger
    this.issuerAPIService.GetComplianceTemplates(obligorId).subscribe(data => {
      this.ComplianceTemplatesArray = data;
    });
  }

  // Load Template File
  loadTemplateFile(TemplateFileDocumentLink: string) {
    this.issuerAPIService.GetTemplateFile(TemplateFileDocumentLink).subscribe(data => {
    });
  }

  // Load Compliance Filing History
  loadComplianceFilingHistory(obligorId: string) {
    debugger;
    this.issuerAPIService.GetComplianceFilingHistory(obligorId).subscribe(data => {
      var countDataTable = 0;
      for (var item in data) {
        if (item != "MEN") {
          var objData = data[item];
          var jsonObj = [];
          for (var i = 0; i < objData["records"].length; i++) {
            var objrecords = {}
            objrecords["documentDesc"] = objData["records"][i].documentDesc;
            objrecords["documentLink"] = objData["records"][i].documentLink;
            objrecords["hasCertificate"] = objData["records"][i].hasCertificate;
            objrecords["filingDate"] = objData["records"][i].filingDate;
            objrecords["dueDate"] = objData["records"][i].dueDate;
            objrecords["isLate"] = objData["records"][i].isLate;
            jsonObj.push(objrecords);
          }
          var productJSON = { "label": objData["label"], "records": jsonObj };
          countDataTable = countDataTable + 1;
          //add tabing index set for events table
          this.FHI = countDataTable;
          this.filingR = 165 + countDataTable;
          this.ComplianceFilingHistoryArray.push(productJSON);
        }
      }

      if (typeof data["MEN"] != "undefined") {
        for (var item in data["MEN"].subsections) {
          var objData = data["MEN"].subsections[item];
          var jsonObj = [];
          for (var i = 0; i < objData["records"].length; i++) {
            var objrecords = {}
            objrecords["documentDesc"] = objData["records"][i].documentDesc;
            objrecords["documentLink"] = objData["records"][i].documentLink;
            objrecords["hasCertificate"] = objData["records"][i].hasCertificate;
            objrecords["filingDate"] = objData["records"][i].filingDate;
            objrecords["anticipatedFileDate"] = objData["records"][i].anticipatedFileDate;
            objrecords["isLate"] = objData["records"][i].isLate;
            jsonObj.push(objrecords);
          }


          var productJSON = { "label": objData["label"], "records": jsonObj };
          countDataTable = countDataTable + 1;
          this.fillinghistorytable_A = countDataTable;
          this.EventNoticesComplianceFilingHistoryArray.push(productJSON);
        }
      }
      this.filingE = this.filingR + countDataTable;
      //this.filingR = countDataTable;
      this.TableFilingHistoryCounttabOverview = countDataTable.toString();
    });
  }

  // Load Compliance Review Findings
  loadComplianceReviewFindings(obligorId: string) {
    this.issuerAPIService.GetComplianceReviewFindings(obligorId).subscribe(data => {
      var countDataTable = 0;
      for (var item in data) {
        if (item != "MEN") {
          var objData = data[item];
          var jsonObj = [];
          if (objData["records"] != null) {
            for (var i = 0; i < objData["records"].length; i++) {
              var objrecords = {}
              objrecords["documentDesc"] = objData["records"][i].documentDesc;
              objrecords["documentLink"] = objData["records"][i].documentLink;
              objrecords["hasCertificate"] = objData["records"][i].hasCertificate;
              objrecords["filingDate"] = objData["records"][i].filingDate;
              objrecords["dueDate"] = objData["records"][i].dueDate;
              objrecords["isLate"] = objData["records"][i].isLate;
              objrecords["daysLate"] = objData["records"][i].daysLate;
              objrecords["findings"] = objData["records"][i].findings;
              objrecords["findingsColor"] = objData["records"][i].findingsColor;
              objrecords["comments"] = objData["records"][i].comments;

              jsonObj.push(objrecords);
            }
          }
          var productJSON = { "label": objData["label"], "records": jsonObj };
          countDataTable = countDataTable + 1;
          this.ComplianceReviewFindingsArray.push(productJSON);
        }
      }

      if (typeof data["MEN"] != "undefined") {
        for (var item in data["MEN"].subsections) {
          var objData = data["MEN"].subsections[item];
          var jsonObj = [];
          if (objData["records"] != null) {
            for (var i = 0; i < objData["records"].length; i++) {
              var objrecords = {}
              objrecords["documentDesc"] = objData["records"][i].documentDesc;
              objrecords["documentLink"] = objData["records"][i].documentLink;
              objrecords["hasCertificate"] = objData["records"][i].hasCertificate;
              objrecords["filingDate"] = objData["records"][i].filingDate;
              objrecords["anticipatedFileDate"] = objData["records"][i].anticipatedFileDate;
              objrecords["isLate"] = objData["records"][i].isLate;
              objrecords["daysLate"] = objData["records"][i].daysLate;
              objrecords["findings"] = objData["records"][i].findings;
              objrecords["findingsColor"] = objData["records"][i].findingsColor;
              objrecords["comments"] = objData["records"][i].comments;
              jsonObj.push(objrecords);
            }
          }
          var productJSON = { "label": objData["label"], "records": jsonObj };
          countDataTable = countDataTable + 1;
          this.EventNoticesComplianceReviewFindingsArray.push(productJSON);
        }
      }
      console.log("no of tables " + countDataTable.toString());
      this.TableFindingsCounttabOverview = countDataTable.toString();
    });
  }

  // Load Issuer CT Documentation
  loadIssuerCTDocumentation(obligorId: string) {
    this.issuerAPIService.GetIssuerCTDocumentation(obligorId).subscribe(data => {
      debugger;
      this.IssuerCTDocumentationArray = data;
    });
  }

  // Load Issuer CT Policies And Procedures
  loadIssuerCTPoliciesAndProcedures(obligorId: string) {
    this.issuerAPIService.GetIssuerCTPoliciesAndProcedures(obligorId).subscribe(data => {
      this.IssuerCTPoliciesAndProceduresArray = data;
    });
  }

  // Load Issuer CT CUSIPs
  loadIssuerCTCUSIPs(obligorId: string) {
    this.issuerAPIService.GetIssuerCTCUSIPs(obligorId).subscribe(data => {
      var countCUSIPs = 0;
      for (var item in data) {
        var objData = data[item];
        countCUSIPs = countCUSIPs + objData.length;
      }
      var CusipReviewed = <HTMLAnchorElement>document.getElementById("CusipReviewed");
      CusipReviewed.innerText = countCUSIPs.toString() + " available";
      var FindingsCusipReviewed = <HTMLAnchorElement>document.getElementById("FindingsCusipReviewed");
      FindingsCusipReviewed.innerText = countCUSIPs.toString() + " available";
      this.CountCUSIPs = countCUSIPs.toString();
    });
  }

}
